import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";

const API = "https://apticketing.fairstead.com/api/public/api"; // v2.1

const COLORS = {
  sidebar:"#1e1f2e", sidebarText:"#a0a3b1", sidebarActive:"#2d2f45",
  accent:"#4f6ef7", accentLight:"#eef1ff",
  vip:"#e84949", vipLight:"#fff0f0",
  rp:"#7c3aed", rpLight:"#f3f0ff",
  yardi:"#0ea5e9", yardiLight:"#f0f9ff",
  success:"#16a34a", successLight:"#f0fdf4",
  warning:"#d97706", warningLight:"#fffbeb",
  border:"#e5e7eb", bg:"#f8f9fc", cardBg:"#ffffff",
  text:"#111827", textMuted:"#6b7280", textLight:"#9ca3af",
};

const INBOXES = ["AP@fairstead.com","AP2@fairstead.com","APteam@fairstead.com","enhancorapteam1@enhancor.com","NewVendors@fairstead.com","Legalbilling@fairstead.com","Utilities@fairstead.com"];
const VIP_KEYWORDS = ["lien","hold","suspension","disconnection","urgent","check run"];
const COMMIT_KEYWORDS = ["commit","committed","selected payment","fedex","overnight","2day"];
const VIP_SENDERS = ["hiren","chad","danny","avi","jeff","lieselle","seth","ana kelly"];
const RP_PROPS = ["realpage","camden","greystar","lincoln"];
const YARDI_PROPS = ["yardi","fairstead","enhancor","affordable"];
const CATEGORIES = ["Invoices","Check Run","New Vendors / Certs","Statements / Recon","Status of Payment","Utility / ISP"];

// IST date helper - server stores IST, display directly
const formatIST = (dateStr, opts = {}) => {
  if (!dateStr) return '';
  const d = new Date(dateStr.replace(' ', 'T'));
  return d.toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit', hour12:true, ...opts });
};
const formatISTDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr.replace(' ', 'T'));
  return d.toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });
};

const FIXED_EMAILS = ['kimberly.swarmer@fairstead.com','jennie.situ@fairstead.com','rachael.burton@fairstead.com','michalene.koewacich@fairstead.com','bridgett.gaona@fairstead.com','rosario.greco@fairstead.com','heather.christian@fairstead.com','valaya.banks@fairstead.com','tammy.veasy@fairstead.com','frances.hollingsworth@fairstead.com','heidy.lopez@fairstead.com','janet.linn@fairstead.com','regla.casimiro@fairstead.com','regina.houston@fairstead.com','denise.bogan@fairstead.com','princess.pierce@fairstead.com','linda.olsen@fairstead.com','anaise.vasquez@fairstead.com','lisbeth.alvarado@fairstead.com','amy.riedinger@fairstead.com','debra.brooks@fairstead.com','chenee.whitfield@fairstead.com','linda.hough@fairstead.com','Courtney.Johnson@fairstead.com','philip.saliba@fairstead.com','david.friedman@fairstead.com','liza.mccorkle@fairstead.com','destiny.brown@fairstead.com','terazia.jones@fairstead.com','kristin.dixon@fairstead.com','jacqueline.jimenez@fairstead.com','gossette.ortiz@fairstead.com','krystal.rover@fairstead.com','janet.willis@fairstead.com','joya.ingalls@fairstead.com','Lori.Pinnock@fairstead.com','jermisha.cass@fairstead.com','vickie.lane@fairstead.com','sharon.wicks@fairstead.com','angela.hendricks@fairstead.com','lisa.sanchez@fairstead.com','tracy.glover@fairstead.com','amy.omeragic@fairstead.com','arelys.macgregor@fairstead.com','monae.singleton@fairstead.com','marisol.rodriguez@fairstead.com','moshe.armour@fairstead.com','tamiyyah.west@fairstead.com','donald.jett@fairstead.com','nesly.segovia@fairstead.com','kari.swoope@fairstead.com','vanessa.zea@fairstead.com','lisset.meyreles@fairstead.com','lakisha.moten@fairstead.com','graylin.stokes@fairstead.com','niurka.ramos@fairstead.com','talori.israel@fairstead.com','robin.walter@fairstead.com','aleta.wilson@fairstead.com','danitra.davis@fairstead.com','april.rosario@fairstead.com','ryan.luckman@fairstead.com','talia.brown@fairstead.com','sherry.lyons@fairstead.com','micah.downs@fairstead.com','stephanie.chase@fairstead.com','barbara.simpson@fairstead.com','tina.sparks@fairstead.com','jennifer.stadther@fairstead.com','michael.tomlinson@fairstead.com','tasha.portis@fairstead.com','faith.goehrig@fairstead.com','tiffany.smith@fairstead.com','dennis.dunn@fairstead.com','anitra.pugh@fairstead.com','sandy.rogers@fairstead.com','lenarge.watkins@fairstead.com','moises.soriano@fairstead.com','angelia.jimenez@fairstead.com','melissa.gray@fairstead.com','dinah.thrasher@fairstead.com','matthew.johnson@fairstead.com','twanda.hamlett@fairstead.com','mindi.garmong@fairstead.com','deborah.smith@fairstead.com','daphne.donaldson@fairstead.com','lisa.sanders@fairstead.com','danielle.lasure@fairstead.com','shaquadia.watson@fairstead.com','tanesha.bothwell@fairstead.com','cindy.scott@fairstead.com','vicki.fontenot@fairstead.com','tracey.sikula@fairstead.com','aretha.lewis@fairstead.com','alexandra.counts@fairstead.com','carrie.clark@fairstead.com','chari.hatcher@fairstead.com','dalila.mayora@fairstead.com','diane.rampersaud@fairstead.com','evelin.castillo@fairstead.com','janie.mcdonald@fairstead.com','jennifer.lau@fairstead.com','jennifer.svoboda@fairstead.com','kathy.strom@fairstead.com','kenneth.hart@fairstead.com','kerry.kramer@fairstead.com','lakesha.hyman@fairstead.com','max.talbott@fairstead.com','melissa.schaub@fairstead.com','nikki.bullock@fairstead.com','patricia.richmond@fairstead.com','sherry.ruhl@fairstead.com','tamara.curry@fairstead.com','tiffanie.moore@fairstead.com','trudy.lucas@fairstead.com','victoria.hair@fairstead.com','yolanda.knee@fairstead.com','Ana.Cardenas@enhancor.com','Yelena.Zinina@enhancor.com','younten.jamtsho@enhancor.com','chad.stelly@enhancor.com','caressa.johnson@enhancor.com','anny.lopez@enhancor.com','valerie.izrailova@enhancor.com','diego.desouza@enhancor.com','vonetta.nelson@enhancor.com','yue.li@enhancor.com','timothy.narine@enhancor.com','fahria.nobel@enhancor.com','hiren.patel@enhancor.com','yvette.bailey@enhancor.com','naylani.delcalle@fairstead.com','Sonya.Leaks@fairstead.com','barbara.johnson@fairstead.com','Marvin.Darlington@fairstead.com','David.Shannon@fairstead.com','Jose.cervantes@fairstead.com','Rene.castro@fairstead.com','Ana.cubas@fairstead.com','wesli.aguilar@fairstead.com','brandy.jordan@fairstead.com','alma.butler@fairstead.com','michael.brown@fairstead.com','henry.smith@fairstead.com','sherry.brown@fairstead.com','stephone.bryson@fairstead.com','henry.connor@fairstead.com','miguel.melchor@fairstead.com','billy.adams@fairstead.com','joseph.thomas@fairstead.com','casaundra.cates@fairstead.com','carol.rivera@fairstead.com','george.brooks@fairstead.com','tiffany.claiborne@fairstead.com','yahkeem.claiborne@fairstead.com','samuel.collins@fairstead.com','jennifer.dickerson@fairstead.com','ronald.duncan@fairstead.com','deasia.hosein@fairstead.com','constance.johnson@fairstead.com','arismel.lemus@fairstead.com','kiane.little@fairstead.com','tyler.mccravy@fairstead.com','lauren.mccullough@fairstead.com','timothy.purcell@fairstead.com','curtis.brunson@fairstead.com','laura.eldridge@fairstead.com','tyrone.lee@fairstead.com','derron.smith@fairstead.com','rose.creech@fairstead.com','joshua.suggs@fairstead.com','ernest.carthage@fairstead.com','mari.gonzalez@fairstead.com','karla.franklin@fairstead.com','lisa.smith@fairstead.com','denise.emerson@fairstead.com','beatrice.angel@fairstead.com','tina.cope@fairstead.com','damani.storms@fairstead.com','brandon.combs@fairstead.com','carlos.mullins@fairstead.com','donald.johnson@fairstead.com','samuel.clark@fairstead.com','Garry.Carrigan@fairstead.com','dennis.hopwood@fairstead.com','freddie.grimes@fairstead.com','edward.bryant@fairstead.com','andy.hawley@fairstead.com','jordan.mattingly@fairstead.com','aaron.hamlett@fairstead.com','nathan.Brossart@fairstead.com','joseph.hicks@fairstead.com','antonio.uraga@fairstead.com','helen.baurle@fairstead.com','sabrina.bargo@fairstead.com','Andrea.Carroll@Fairstead.com','bethany.barnes@fairstead.com','christy.mooney@fairstead.com','melody.wilson@fairstead.com','delanda.cox@fairstead.com','ronald.foster@fairstead.com','marty.ledlow@fairstead.com','steven.napier@fairstead.com','jeremy.bowen@fairstead.com','jessica.hayes@fairstead.com','nathan.hood@fairstead.com','shelley.scoggins@fairstead.com','randy.clark@fairstead.com','AP@fairstead.com','AP2@fairstead.com','APteam@fairstead.com','enhancorapteam1@enhancor.com','NewVendors@fairstead.com','Legalbilling@fairstead.com','Utilities@fairstead.com','Enhancoraccountants@enhancor.com','certs@fairstead.com','enhancor.contracthelpdesk@fairstead.com','pettycash@fairstead.com'];

const AGENTS = [
  "Santosh Marri","Ronak Shah",
  "Vaibhav Raut","Sanskruti Vighe","Kaustubh Kulkarni","Avinasah Bhoknal","Gaurav Kale","Sanjana Punda",
  "Sneha Marathe","Sushrut Dingare","Rohini Jadhav","Yasin Shaikh","Suraj Panse",
  "Shruti Jadhav","Mahesh Wankhade",
  "Valerie","Rajesh","Parshuraam Kolie.",
];
const STATUSES = ["Open","In Progress","On Hold","Escalated","Closed","No Action Required"];
const VIEW_ALL_AGENTS = [];

// ── Shared UI primitives ──────────────────────────────────────────────────────
const Avatar = ({ name, size=32, color=COLORS.accent }) => (
  <div style={{ width:size, height:size, borderRadius:"50%", background:color+"22", color, fontSize:size*0.36, fontWeight:500, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
    {name.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase()}
  </div>
);
const Badge = ({ label, color, bg }) => (
  <span style={{ fontSize:11, fontWeight:500, padding:"2px 8px", borderRadius:99, background:bg, color, whiteSpace:"nowrap" }}>{label}</span>
);
const Card = ({ children, style={} }) => (
  <div style={{ background:COLORS.cardBg, border:`1px solid ${COLORS.border}`, borderRadius:12, ...style }}>{children}</div>
);
const bucketBadge = b => b==="RP" ? <Badge label="RP" color={COLORS.rp} bg={COLORS.rpLight}/> : b==="YARDI" ? <Badge label="YARDI" color={COLORS.yardi} bg={COLORS.yardiLight}/> : <Badge label="—" color={COLORS.textMuted} bg={COLORS.bg}/>;
const statusBadge = s => {
  const map = { Open:[COLORS.accent,COLORS.accentLight], "In Progress":[COLORS.warning,COLORS.warningLight], "On Hold":["#9333ea","#f3e8ff"], Escalated:[COLORS.vip,COLORS.vipLight], Resolved:[COLORS.success,COLORS.successLight], Closed:[COLORS.textMuted,"#f3f4f6"], "No Action Required":["#64748b","#f1f5f9"] };
  const [c,bg]=map[s]||[COLORS.textMuted,"#f3f4f6"];
  return <Badge label={s} color={c} bg={bg}/>;
};

// ── AttachmentsSection ────────────────────────────────────────────────────────
function AttachmentsSection({ ticketId }) {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    fetch(`${API}/tickets/${ticketId}/attachments`)
      .then(r=>r.json()).then(d=>{ setAttachments(Array.isArray(d)?d:[]); setLoading(false); }).catch(()=>setLoading(false));
  }, [ticketId]);
  if (loading || !attachments.length) return null;
  const formatSize = b => b>1048576?(b/1048576).toFixed(1)+' MB':b>1024?(b/1024).toFixed(0)+' KB':b+' B';
  const fileIcon = m => m?.includes('pdf')?'📄':m?.includes('image')?'🖼':m?.includes('excel')||m?.includes('spreadsheet')?'📊':m?.includes('word')||m?.includes('document')?'📝':'📎';
  return (
    <div style={{ marginBottom:16 }}>
      <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:8, fontWeight:500 }}>📎 Attachments ({attachments.length})</div>
      <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
        {attachments.map(a=>(
          <a key={a.id} href={`${API}/attachments/${a.id}/view`} target="_blank" rel="noreferrer"
            style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 12px", background:COLORS.bg, border:`1px solid ${COLORS.border}`, borderRadius:8, textDecoration:"none", color:COLORS.text, fontSize:12 }}>
            <span style={{ fontSize:16 }}>{fileIcon(a.mime_type)}</span>
            <div>
              <div style={{ fontWeight:500, color:COLORS.text, maxWidth:180, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.filename}</div>
              <div style={{ fontSize:10, color:COLORS.textMuted }}>{formatSize(a.size)}</div>
            </div>
            <span style={{ fontSize:10, color:COLORS.accent, marginLeft:4 }}>↗</span>
          </a>
        ))}
      </div>
    </div>
  );
}

// ── NotesSection ──────────────────────────────────────────────────────────────
function NotesSection({ ticketId, currentUser }) {
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [saving, setSaving] = useState(false);
  const noteEditorRef = useRef(null);
  const { handleKeyUp: handleMentionKeyUp, Dropdown: MentionDropdown } = useMention(noteEditorRef, null);

  const fetchNotes = useCallback(() => {
    fetch(`${API}/tickets/${ticketId}/notes`)
      .then(r=>r.json()).then(d=>setNotes(Array.isArray(d)?d:[])).catch(()=>{});
  }, [ticketId]);

  useEffect(() => {
    setNotes([]);
    setNewNote("");
    if (noteEditorRef.current) noteEditorRef.current.innerHTML = '';
    fetchNotes();
  }, [ticketId, fetchNotes]);

  const addNote = async () => {
    if (!newNote.trim()) return;
    setSaving(true);
    try {
      await fetch(`${API}/tickets/${ticketId}/notes`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ note: newNote, agent_name: currentUser?.name || 'Agent' })
      });
      setNewNote("");
      if (noteEditorRef.current) noteEditorRef.current.innerHTML = '';
      fetchNotes();
    } catch(e) {}
    setSaving(false);
  };

  const deleteNote = async (id) => {
    if (!window.confirm("Delete this note?")) return;
    await fetch(`${API}/notes/${id}`, { method:'DELETE' });
    fetchNotes();
  };

  return (
    <div style={{ marginBottom:16 }}>
      <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:10, fontWeight:500 }}>📝 Internal Notes ({notes.length})</div>
      <div style={{ background:COLORS.bg, border:`1px solid ${COLORS.border}`, borderRadius:8, padding:12, marginBottom:12 }}>
        <div style={{ position:'relative' }}>
<div
  ref={noteEditorRef}
          contentEditable={true}
          suppressContentEditableWarning={true}
          onInput={e => setNewNote(e.currentTarget.innerHTML)}
          onKeyUp={handleMentionKeyUp}
          onPaste={e => {
            const items = e.clipboardData?.items;
            if (!items) return;
            for (let i = 0; i < items.length; i++) {
              if (items[i].type.startsWith('image/')) {
                e.preventDefault();
                const file = items[i].getAsFile();
                if (!file) return;
                const reader = new FileReader();
                reader.onload = ev => {
                  const img = document.createElement('img');
                  img.src = ev.target.result;
                  img.style.cssText = 'max-width:100%;min-width:400px;height:auto;display:block;margin:4px 0;';
                  if (noteEditorRef.current) noteEditorRef.current.appendChild(img);
                  setNewNote(noteEditorRef.current?.innerHTML || '');
                };
                reader.readAsDataURL(file);
                return;
              }
            }
          }}
          data-placeholder="Add an internal note... (Ctrl+V to paste screenshot)"
         style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:6, padding:"8px 10px", fontSize:12, outline:"none", minHeight:80, fontFamily:"system-ui,sans-serif", boxSizing:"border-box", color:COLORS.text, marginBottom:8 }}
        />
{MentionDropdown}
</div>
        <button onClick={addNote} disabled={saving||!newNote.trim()}
          style={{ padding:"6px 16px", background:saving||!newNote.trim()?COLORS.textLight:COLORS.accent, color:"#fff", border:"none", borderRadius:6, fontSize:12, fontWeight:500, cursor:saving||!newNote.trim()?"not-allowed":"pointer" }}>
          {saving ? "Saving..." : "+ Add Note"}
        </button>
      </div>
      {notes.map(n=>(
        <div key={n.id} style={{ background:"#fffbeb", border:`1px solid #fde68a`, borderRadius:8, padding:12, marginBottom:8 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <Avatar name={n.agent_name} size={24} color={COLORS.warning}/>
              <span style={{ fontSize:11, fontWeight:600, color:COLORS.text }}>{n.agent_name}</span>
              <span style={{ fontSize:10, color:COLORS.textMuted }}>{formatIST(n.created_at)}</span>
            </div>
            <button onClick={()=>deleteNote(n.id)} style={{ background:"none", border:"none", cursor:"pointer", color:COLORS.vip, fontSize:12 }}>🗑</button>
          </div>
          <div style={{ fontSize:12, color:COLORS.text, whiteSpace:"pre-wrap" }} className="email-body" dangerouslySetInnerHTML={{ __html: n.note }}/>
        </div>
      ))}
      {notes.length===0 && <div style={{ fontSize:11, color:COLORS.textMuted, textAlign:"center", padding:12 }}>No notes yet</div>}
    </div>
  );
}

// ── ActivityLog ───────────────────────────────────────────────────────────────
function ActivityLog({ ticketId }) {
  const [logs, setLogs] = useState([]);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!show) return;
    fetch(`${API}/tickets/${ticketId}/logs`)
      .then(r=>r.json()).then(d=>setLogs(Array.isArray(d)?d:[])).catch(()=>{});
  }, [ticketId, show]);
  const icons = { created:'🎫', status_change:'🔄', assignment_change:'👤', reply_sent:'📧' };
  return (
    <div style={{ marginBottom:16 }}>
      <button onClick={()=>setShow(p=>!p)} style={{ fontSize:11, color:COLORS.textMuted, fontWeight:500, background:"none", border:"none", cursor:"pointer", padding:0, marginBottom:8 }}>
        📋 Activity Log {show ? "▲" : "▼"}
      </button>
      {show && (
        <div style={{ borderLeft:`2px solid ${COLORS.border}`, paddingLeft:12, marginLeft:4 }}>
          {logs.length === 0 && <div style={{ fontSize:11, color:COLORS.textMuted, padding:"8px 0" }}>No activity yet</div>}
          {logs.map(log=>(
            <div key={log.id} style={{ marginBottom:12 }}>
              <div style={{ fontSize:11, color:COLORS.text, fontWeight:500 }}>{icons[log.action] || '📋'} {log.description}</div>
              <div style={{ fontSize:10, color:COLORS.textMuted }}>{log.performed_by} · {formatIST(log.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── ForwardModal ──────────────────────────────────────────────────────────────
function ForwardModal({ ticket, onClose, showToast }) {
  const [to, setTo] = useState("");
  const [note, setNote] = useState("");
  const [sending, setSending] = useState(false);
  const forwardEditorRef = useRef(null);

  const send = async () => {
    if (!to.trim()) return showToast("Enter email address");
    setSending(true);
    try {
      const res = await fetch(`${API}/tickets/${ticket.id}/forward`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ to, note })
      });
      const data = await res.json();
      if (data.success) { showToast("✅ Email forwarded!"); onClose(); }
      else showToast("❌ " + data.message);
    } catch(e) { showToast("❌ " + e.message); }
    setSending(false);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.4)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:400 }}>
      <Card style={{ width:460, padding:24 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <div style={{ fontWeight:600, fontSize:15, color:COLORS.text }}>↪ Forward Email</div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", fontSize:18, color:COLORS.textMuted }}>×</button>
        </div>
        <div style={{ background:COLORS.bg, borderRadius:8, padding:"8px 12px", marginBottom:12, fontSize:12 }}>
          <span style={{ color:COLORS.textMuted }}>Subject: </span>
          <span style={{ color:COLORS.text }}>FWD: {ticket.subject}</span>
        </div>
        <div style={{ marginBottom:12 }}>
          <div style={{ fontSize:12, color:COLORS.textMuted, marginBottom:4 }}>Forward To *</div>
          <input type="email" value={to} onChange={e=>setTo(e.target.value)} placeholder="email@example.com"
            style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"8px 10px", fontSize:12, outline:"none", boxSizing:"border-box", color:COLORS.text, background:COLORS.bg }}/>
        </div>
        <div style={{ marginBottom:16 }}>
          <div style={{ fontSize:12, color:COLORS.textMuted, marginBottom:4 }}>Add Note (optional)</div>
          <div
            ref={forwardEditorRef}
            contentEditable={true}
            suppressContentEditableWarning={true}
            onInput={e => setNote(e.currentTarget.innerHTML)}
            onPaste={e => {
              const items = e.clipboardData?.items;
              if (!items) return;
              for (let i = 0; i < items.length; i++) {
                if (items[i].type.startsWith('image/')) {
                  e.preventDefault();
                  const file = items[i].getAsFile();
                  if (!file) return;
                  const reader = new FileReader();
                  reader.onload = ev => {
                    const img = document.createElement('img');
                    img.src = ev.target.result;
                    img.style.cssText = 'max-width:100%;min-width:400px;height:auto;display:block;margin:4px 0;';
                    if (forwardEditorRef.current) forwardEditorRef.current.appendChild(img);
                    setNote(forwardEditorRef.current?.innerHTML || '');
                  };
                  reader.readAsDataURL(file);
                  return;
                }
              }
            }}
            data-placeholder="Add a note to the forwarded email... (Ctrl+V to paste screenshot)"
            style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"8px 10px", fontSize:12, outline:"none", minHeight:80, fontFamily:"system-ui,sans-serif", boxSizing:"border-box", color:COLORS.text }}
          />
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={onClose} style={{ flex:1, padding:"8px", border:`1px solid ${COLORS.border}`, background:"transparent", color:COLORS.textMuted, borderRadius:8, fontSize:12, cursor:"pointer" }}>Cancel</button>
          <button onClick={send} disabled={sending}
            style={{ flex:1, padding:"8px", background:sending?COLORS.textLight:COLORS.accent, color:"#fff", border:"none", borderRadius:8, fontSize:12, fontWeight:500, cursor:sending?"not-allowed":"pointer" }}>
            {sending ? "Forwarding..." : "↪ Forward"}
          </button>
        </div>
      </Card>
    </div>
  );
}

// ── CcEmailInput ──────────────────────────────────────────────────────────────
function CcEmailInput({ cc, setCc }) {
  const [suggestions, setSuggestions] = useState([]);
  const [showSug, setShowSug] = useState(false);
  const wrapRef = useRef(null);
  const lastWord = cc.split(',').pop().trim();

  useEffect(() => {
    if (lastWord.length < 2) { setSuggestions([]); setShowSug(false); return; }
    const q = lastWord.toLowerCase();
    const fixed = FIXED_EMAILS.filter(e => e.toLowerCase().includes(q)).slice(0, 6);
    fetch(`${API}/tickets/email-suggestions?q=${encodeURIComponent(lastWord)}`)
      .then(r => r.json())
      .then(data => {
        const hist = (data || []).filter(e => !fixed.map(x=>x.toLowerCase()).includes(e.toLowerCase())).slice(0, 4);
        setSuggestions([...fixed, ...hist].slice(0, 8));
        setShowSug(true);
      }).catch(() => { setSuggestions(fixed); setShowSug(fixed.length > 0); });
  }, [lastWord]);

  useEffect(() => {
    const handler = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setShowSug(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selectEmail = (email) => {
    const parts = cc.split(',');
    parts[parts.length - 1] = email;
    setCc(parts.join(',') + ',');
    setSuggestions([]);
    setShowSug(false);
  };

  return (
    <div ref={wrapRef} style={{ position:'relative' }}>
      <input value={cc} onChange={e=>setCc(e.target.value)} placeholder="email1, email2..."
        onFocus={() => lastWord.length >= 2 && setShowSug(true)}
        style={{ border:"none", outline:"none", fontSize:12, background:"transparent", width:"100%", color:COLORS.text }}/>
      {showSug && suggestions.length > 0 && (
        <div style={{ position:'absolute', top:'100%', left:0, background:'#fff', border:`1px solid ${COLORS.border}`, borderRadius:8, boxShadow:'0 4px 12px rgba(0,0,0,.15)', zIndex:600, minWidth:250, maxHeight:200, overflowY:'auto' }}>
          {suggestions.map(email => (
            <div key={email} onClick={() => selectEmail(email)}
              style={{ padding:'7px 12px', fontSize:12, cursor:'pointer', color:COLORS.text, borderBottom:`1px solid ${COLORS.border}` }}
              onMouseEnter={e => e.currentTarget.style.background=COLORS.bg}
              onMouseLeave={e => e.currentTarget.style.background='transparent'}>
              {email}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── ToEmailInput ──────────────────────────────────────────────────────────────
function ToEmailInput({ toEmails, setToEmails }) {
  const [inputVal, setInputVal] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSug, setShowSug] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (inputVal.length < 2) { setSuggestions([]); setShowSug(false); return; }
    const q = inputVal.toLowerCase();
    const fixed = FIXED_EMAILS.filter(e => e.toLowerCase().includes(q)).slice(0, 6);
    fetch(`${API}/tickets/email-suggestions?q=${encodeURIComponent(inputVal)}`)
      .then(r => r.json())
      .then(data => {
        const hist = (data || []).filter(e => !fixed.map(x=>x.toLowerCase()).includes(e.toLowerCase())).slice(0, 4);
        setSuggestions([...fixed, ...hist].slice(0, 8));
        setShowSug(true);
      }).catch(() => { setSuggestions(fixed); setShowSug(fixed.length > 0); });
  }, [inputVal]);

  useEffect(() => {
    const handler = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setShowSug(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const addEmail = (email) => {
    const trimmed = email.trim().replace(',','');
    if (trimmed && !toEmails.includes(trimmed)) setToEmails(p => [...p, trimmed]);
    setInputVal('');
    setSuggestions([]);
    setShowSug(false);
  };

  return (
    <div ref={wrapRef} style={{ position:'relative', flex:1 }}>
      <input
        value={inputVal}
        onChange={e => setInputVal(e.target.value)}
        onKeyDown={e => { if(e.key==='Enter'||e.key===',') { e.preventDefault(); if(inputVal.trim()) addEmail(inputVal); } }}
        placeholder="Add email + Enter"
        style={{ border:"none", outline:"none", fontSize:11, background:"transparent", color:COLORS.text, minWidth:150, width:'100%' }}
      />
      {showSug && suggestions.length > 0 && (
        <div style={{ position:'absolute', top:'100%', left:0, background:'#fff', border:`1px solid ${COLORS.border}`, borderRadius:8, boxShadow:'0 4px 12px rgba(0,0,0,.15)', zIndex:600, minWidth:250, maxHeight:200, overflowY:'auto' }}>
          {suggestions.map(email => (
            <div key={email} onClick={() => addEmail(email)}
              style={{ padding:'7px 12px', fontSize:12, cursor:'pointer', color:COLORS.text, borderBottom:`1px solid ${COLORS.border}` }}
              onMouseEnter={e => e.currentTarget.style.background=COLORS.bg}
              onMouseLeave={e => e.currentTarget.style.background='transparent'}>
              {email}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── ActivityLogInline (header toolbar version) ────────────────────────────────
function ActivityLogInline({ ticketId }) {
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const toggle = () => {
    if (!open) {
      setLoading(true);
      fetch(`${API}/tickets/${ticketId}/logs`)
        .then(r => r.json())
        .then(d => { setLogs(Array.isArray(d) ? d : []); setLoading(false); })
        .catch(() => setLoading(false));
    }
    setOpen(p => !p);
  };

  // Reset when ticket changes
  useEffect(() => { setOpen(false); setLogs([]); }, [ticketId]);

  const icons = { created:'🎫', status_change:'🔄', assignment_change:'👤', reply_sent:'📧' };

  return (
    <div ref={ref} style={{ position:"relative" }}>
      <button onClick={toggle}
        style={{ padding:"7px 14px", borderRadius:8, border:`1px solid ${COLORS.border}`, background:open?COLORS.accentLight:COLORS.cardBg, color:open?COLORS.accent:COLORS.text, fontSize:12, cursor:"pointer", fontWeight:500, display:"flex", alignItems:"center", gap:5 }}>
        📋 Activity {open ? "▲" : "▼"}
      </button>
      {open && (
        <div style={{ position:"absolute", top:"calc(100% + 8px)", right:0, width:340, background:COLORS.cardBg, border:`1px solid ${COLORS.border}`, borderRadius:12, boxShadow:"0 8px 32px rgba(0,0,0,.15)", zIndex:300, padding:16, maxHeight:360, overflowY:"auto" }}>
          <div style={{ fontSize:12, fontWeight:600, color:COLORS.text, marginBottom:12 }}>📋 Activity Log</div>
          {loading && <div style={{ fontSize:11, color:COLORS.textMuted, textAlign:"center", padding:12 }}>Loading...</div>}
          {!loading && logs.length === 0 && <div style={{ fontSize:11, color:COLORS.textMuted, textAlign:"center", padding:12 }}>No activity yet</div>}
          {!loading && logs.map(log => (
            <div key={log.id} style={{ borderLeft:`2px solid ${COLORS.border}`, paddingLeft:10, marginBottom:12 }}>
              <div style={{ fontSize:11, color:COLORS.text, fontWeight:500 }}>{icons[log.action] || '📋'} {log.description}</div>
              <div style={{ fontSize:10, color:COLORS.textMuted, marginTop:2 }}>{log.performed_by} · {formatIST(log.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
// ── EmailBodyFrame ────────────────────────────────────────────────────────────
function EmailBodyFrame({ html }) {
  const iframeRef = useRef(null);
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html><head><style>
        body { margin:8px; font-family:system-ui,sans-serif; font-size:12px; background:#fff !important; color:#111827; }
        * { background-color: inherit !important; }
        body > * { background-color: transparent !important; }
        table td, table th { background-color: inherit !important; }
        img { max-width:100% !important; height:auto !important; }
        table { border-collapse:collapse; }
      </style></head>
      <body>${html}</body></html>
    `);
    doc.close();
    // Auto-resize iframe to content height
    setTimeout(() => {
      try { iframe.style.height = doc.body.scrollHeight + 'px'; } catch(e) {}
    }, 100);
  }, [html]);
  return (
    <iframe
      ref={iframeRef}
      style={{ width:"100%", border:"none", minHeight:100 }}
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      title="email-body"
    />
  );
}
// ── useMention ────────────────────────────────────────────────────────────────
const AGENT_EMAILS = {
  "Santosh Marri": "Santosh.Marri@enhancor.com",
  "Ronak Shah": "Ronak.Shah@enhancor.com",
  "Vaibhav Raut": "Vaibhav.Raut@enhancor.com",
  "Sanskruti Vighe": "Sanskruti.Vighe@enhancor.com",
  "Kaustubh Kulkarni": "Kaustubh.Kulkarni@enhancor.com",
  "Avinasah Bhoknal": "Avinasah.Bhoknal@enhancor.com",
  "Gaurav Kale": "Gaurav.Kale@enhancor.com",
  "Sanjana Punda": "Sanjana.Punda@enhancor.com",
  "Sneha Marathe": "Sneha.Marathe@enhancor.com",
  "Sushrut Dingare": "Sushrut.Dingare@enhancor.com",
  "Rohini Jadhav": "Rohini.Jadhav@enhancor.com",
  "Yasin Shaikh": "Yasin.Shaikh@enhancor.com",
  "Suraj Panse": "Suraj.Panse@enhancor.com",
  "Shruti Jadhav": "Shruti.Jadhav@enhancor.com",
  "Mahesh Wankhade": "Mahesh.Wankhade@enhancor.com",
  "Parshuraam Kolie.": "Parshuraam@enhancor.com",
};

function useMention(editorRef, onSelectEmail) {
  const [show, setShow] = useState(false);
  const [query, setQuery] = useState('');
  const [pos, setPos] = useState({ top:0, left:0 });
  const allMentions = [
  ...AGENTS.map(a => ({ name: a, email: AGENT_EMAILS[a] || '' })),
  ...FIXED_EMAILS.filter(e => !Object.values(AGENT_EMAILS).includes(e)).map(e => ({ name: e.split('@')[0].replace('.', ' '), email: e })),
];
const filtered = allMentions.filter(a => 
  a.name.toLowerCase().includes(query.toLowerCase()) || 
  a.email.toLowerCase().includes(query.toLowerCase())
).slice(0, 8);

  const handleKeyUp = () => {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;
    const range = sel.getRangeAt(0);
    const text = range.startContainer.textContent || '';
    const idx = text.lastIndexOf('@', range.startOffset - 1);
    if (idx !== -1) {
      const q = text.substring(idx + 1, range.startOffset);
      if (!q.includes(' ')) {
        setQuery(q);
        const rect = range.getBoundingClientRect();
        const editorRect = editorRef.current?.getBoundingClientRect();
        if (editorRect) {
          setPos({ top: rect.bottom - editorRect.top + 4, left: rect.left - editorRect.left });
        }
        setShow(true);
        return;
      }
    }
    setShow(false);
  };

  const select = (agent) => {
    const email = AGENT_EMAILS[agent] || '';
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      const range = sel.getRangeAt(0);
      const text = range.startContainer.textContent || '';
      const idx = text.lastIndexOf('@', range.startOffset - 1);
      if (idx !== -1) {
        range.setStart(range.startContainer, idx);
        range.setEnd(range.startContainer, range.startOffset);
        range.deleteContents();
        const span = document.createElement('span');
        span.style.cssText = `color:${COLORS.accent};font-weight:600;`;
        span.textContent = `@${agent}`;
        range.insertNode(span);
        range.setStartAfter(span);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
    if (onSelectEmail && email) onSelectEmail(email);
    setShow(false);
    setQuery('');
    editorRef.current?.focus();
  };

  const Dropdown = show && filtered.length > 0 ? (
    <div style={{ position:'absolute', top:pos.top, left:pos.left, background:'#fff', border:`1px solid ${COLORS.border}`, borderRadius:8, boxShadow:'0 4px 16px rgba(0,0,0,.15)', zIndex:700, minWidth:220, maxHeight:220, overflowY:'auto' }}>
      {filtered.map(item => (
        <div key={item.email} onMouseDown={e=>{ e.preventDefault(); select(item); }}
          style={{ padding:'8px 12px', fontSize:12, cursor:'pointer', color:COLORS.text, borderBottom:`1px solid ${COLORS.border}`, display:'flex', alignItems:'center', gap:8 }}
          onMouseEnter={e=>e.currentTarget.style.background=COLORS.bg}
          onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
          <Avatar name={item.name} size={22} color={COLORS.accent}/>
          <div>
            <div style={{ fontWeight:500 }}>{item.name}</div>
            <div style={{ fontSize:10, color:COLORS.textMuted }}>{item.email}</div>
          </div>
        </div>
      ))}
    </div>
  ) : null;

  return { handleKeyUp, Dropdown, hide: () => setShow(false) };
}


// ── DropdownReply ─────────────────────────────────────────────────────────────
function DropdownReply({ ticket, showToast, onReplySent }) {
  const [open, setOpen] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [replyType, setReplyType] = useState("reply");
  const [toEmails, setToEmails] = useState([ticket.from]);
  const [cc, setCc] = useState("");
  const [sending, setSending] = useState(false);
  const [showCC, setShowCC] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const fileRef = useRef(null);
  const ref = useRef(null);
  const editorRef = useRef(null);
  const savedSelectionRef = useRef(null); // saves cursor/selection before toolbar steals focus
  const { handleKeyUp: handleMentionKeyUp, Dropdown: MentionDropdown } = useMention(editorRef, (email) => {
  if (!toEmails.includes(email)) setToEmails(p => [...p, email]);
});

  const buildSignature = useCallback(() => {
    const agentName = ticket.assigned_to || '';
    const fromEmail = (ticket.from || '').toLowerCase();
    const isInternal = fromEmail.includes('@fairstead.com') || fromEmail.includes('@enhancor.com');
    if (isInternal) {
      return `<br><br><div style="font-family:Calibri,sans-serif;font-size:11pt;">Thank you,<br><br>${agentName}<br>AP Analyst</div>`;
    }
    return `<br><br><div style="font-family:Calibri,sans-serif;font-size:11pt;">Thank you,<br><br>Accounts Payable<br>Fairstead</div>`;
  }, [ticket.assigned_to, ticket.from]);

  // Reset all state when the ticket changes
  useEffect(() => {
    setCc("");
    setShowCC(false);
    setReplyType("reply");
    setToEmails([ticket.from]);
    setAttachments([]);
    setOpen(false);
    const sig = buildSignature();
    setReplyText(sig);
    if (editorRef.current) editorRef.current.innerHTML = sig;
  }, [ticket.id, buildSignature]);

  // Close panel when clicking outside
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const removeToEmail = (email) => setToEmails(p => p.filter(e => e !== email));

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setAttachments(p => [...p, ...files]);
  };

  const removeAttachment = (name) => setAttachments(p => p.filter(f => f.name !== name));

  const send = async () => {
    const trimmedReply = editorRef.current?.innerHTML || replyText;
    if (!trimmedReply.trim()) return showToast("Type a reply first");
    if (toEmails.length === 0) return showToast("Add at least one recipient");
    setSending(true);
    try {
      let res;
      if (attachments.length > 0) {
        const formData = new FormData();
        formData.append('body', trimmedReply);
        formData.append('reply_type', replyType);
        formData.append('to', toEmails.join(','));
        if (cc) formData.append('cc', cc);
        attachments.forEach(f => formData.append('attachments[]', f));
        res = await fetch(`${API}/tickets/${ticket.id}/reply`, { method:'POST', body: formData });
      } else {
        res = await fetch(`${API}/tickets/${ticket.id}/reply`, {
          method:'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ body: trimmedReply, reply_type: replyType, to: toEmails.join(','), cc: cc || '' })
        });
      }
      const text = await res.text();
      let data = {};
      try { data = JSON.parse(text); } catch(e) { console.error('Response:', text); }
      if (res.ok && data.success) {
        showToast("✅ Reply sent!");
        onReplySent(`\n\n--- Sent reply to ${toEmails.join(', ')} ---\n${trimmedReply}`);
        const sig = buildSignature();
        setReplyText(sig);
        setCc("");
        setAttachments([]);
        setOpen(false);
        if (editorRef.current) editorRef.current.innerHTML = sig;
      } else {
        showToast("❌ " + (data.message || text.substring(0,100) || "Failed"));
      }
    } catch(e) { showToast("❌ " + e.message); }
    setSending(false);
  };

  const openReply = () => {
    setReplyType("reply");
    setToEmails([ticket.from]);
    setCc("");
    setShowCC(false);
    const sig = buildSignature();
    setReplyText(sig);
    setOpen(true);
    setTimeout(() => { if (editorRef.current) editorRef.current.innerHTML = sig; }, 50);
  };

  const openReplyAll = () => {
    setReplyType("reply_all");
    const toList = [ticket.from];
    if (ticket.to_recipients) {
      ticket.to_recipients.split(',').forEach(e => {
        const trimmed = e.trim();
        if (trimmed && !toList.includes(trimmed)) toList.push(trimmed);
      });
    }
    setToEmails(toList);
    if (ticket.cc) { setCc(ticket.cc); setShowCC(true); }
    const sig = buildSignature();
    setReplyText(sig);
    setOpen(true);
    setTimeout(() => { if (editorRef.current) editorRef.current.innerHTML = sig; }, 50);
  };

  const cancel = () => {
    const sig = buildSignature();
    setReplyText(sig);
    setOpen(false);
    if (editorRef.current) editorRef.current.innerHTML = sig;
  };

  return (
    <div ref={ref} style={{ position:"relative" }}>
      <div style={{ display:"flex", gap:2 }}>
        <button onClick={openReply}
          style={{ display:"flex", alignItems:"center", gap:6, padding:"7px 14px", borderRadius:"8px 0 0 8px", border:`1.5px solid ${COLORS.accent}`, background:COLORS.accent, color:"#fff", fontSize:12, cursor:"pointer", fontWeight:600 }}>
          ↩ Reply
        </button>
        <button onClick={openReplyAll}
          style={{ padding:"7px 10px", borderRadius:"0 8px 8px 0", border:`1.5px solid ${COLORS.accent}`, borderLeft:`1px solid #6b85f8`, background:COLORS.accent, color:"#fff", fontSize:12, cursor:"pointer" }}>
          ▼
        </button>
      </div>

      {open && (
        <div style={{ position:"absolute", top:"calc(100% + 8px)", right:0, width:560, background:COLORS.cardBg, border:`1.5px solid ${COLORS.border}`, borderRadius:12, boxShadow:"0 8px 32px rgba(0,0,0,.15)", zIndex:300, padding:20 }}>
          {/* Header row */}
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
            <div style={{ fontSize:13, fontWeight:600, color:COLORS.text }}>New Reply</div>
            <div style={{ display:"flex", gap:6 }}>
              <button onClick={()=>{ setReplyType("reply"); setToEmails([ticket.from]); }} style={{ padding:"4px 10px", borderRadius:6, border:`1px solid ${replyType==="reply"?COLORS.accent:COLORS.border}`, background:replyType==="reply"?COLORS.accentLight:"transparent", color:replyType==="reply"?COLORS.accent:COLORS.textMuted, fontSize:11, cursor:"pointer" }}>↩ Reply</button>
              <button onClick={()=>{ setReplyType("reply_all"); const toList=[ticket.from]; if(ticket.to_recipients){ticket.to_recipients.split(',').forEach(e=>{const t=e.trim();if(t&&!toList.includes(t))toList.push(t);})} setToEmails(toList); if(ticket.cc){setCc(ticket.cc);setShowCC(true);} }} style={{ padding:"4px 10px", borderRadius:6, border:`1px solid ${replyType==="reply_all"?COLORS.accent:COLORS.border}`, background:replyType==="reply_all"?COLORS.accentLight:"transparent", color:replyType==="reply_all"?COLORS.accent:COLORS.textMuted, fontSize:11, cursor:"pointer" }}>↩↩ Reply All</button>
              <button onClick={()=>setShowCC(p=>!p)} style={{ padding:"4px 10px", borderRadius:6, border:`1px solid ${showCC?COLORS.accent:COLORS.border}`, background:showCC?COLORS.accentLight:"transparent", color:showCC?COLORS.accent:COLORS.textMuted, fontSize:11, cursor:"pointer" }}>+ CC</button>
              <button onClick={cancel} style={{ padding:"4px 8px", borderRadius:6, border:"none", background:"transparent", color:COLORS.textMuted, fontSize:14, cursor:"pointer" }}>×</button>
            </div>
          </div>

          {/* To field */}
          <div style={{ background:COLORS.bg, borderRadius:8, padding:"6px 10px", marginBottom:8 }}>
            <span style={{ fontSize:11, color:COLORS.textMuted, fontWeight:500 }}>To: </span>
            <div style={{ display:"flex", flexWrap:"wrap", gap:4, marginTop:4 }}>
              {toEmails.map(email=>(
                <span key={email} style={{ display:"flex", alignItems:"center", gap:4, background:COLORS.accentLight, color:COLORS.accent, padding:"2px 8px", borderRadius:99, fontSize:11, whiteSpace:"nowrap" }}>
                  {email}
                  <button onClick={()=>removeToEmail(email)} style={{ background:"none", border:"none", cursor:"pointer", color:COLORS.accent, fontSize:12, padding:0, lineHeight:1 }}>×</button>
                </span>
              ))}
              <ToEmailInput toEmails={toEmails} setToEmails={setToEmails} />
            </div>
          </div>

          {/* CC field */}
          {showCC && (
            <div style={{ background:COLORS.bg, borderRadius:8, padding:"6px 12px", marginBottom:8, display:"flex", alignItems:"center" }}>
              <span style={{ color:COLORS.textMuted, fontWeight:500, fontSize:12, marginRight:4 }}>CC: </span>
              <div style={{ flex:1, position:"relative" }}>
                <CcEmailInput cc={cc} setCc={setCc} />
              </div>
            </div>
          )}

          {/* Formatting toolbar */}
          <div style={{ display:"flex", gap:4, padding:"6px 8px", background:COLORS.bg, border:`1px solid ${COLORS.border}`, borderRadius:"8px 8px 0 0", borderBottom:"none", flexWrap:"wrap" }}>
            {[["bold","B"],["italic","I"],["underline","U"]].map(([cmd,label])=>(
              <button key={cmd}
                onMouseDown={e => {
                  e.preventDefault();
                  // Restore focus + saved selection to editor before executing
                  editorRef.current?.focus();
                  const sel = window.getSelection();
                  if (sel && savedSelectionRef.current) {
                    sel.removeAllRanges();
                    sel.addRange(savedSelectionRef.current);
                  }
                  document.execCommand(cmd);
                  setReplyText(editorRef.current?.innerHTML || '');
                }}
                style={{ padding:"2px 8px", borderRadius:4, border:`1px solid ${COLORS.border}`, background:"#fff", cursor:"pointer", fontSize:12, fontWeight:cmd==="bold"?700:400, fontStyle:cmd==="italic"?"italic":"normal", textDecoration:cmd==="underline"?"underline":"none" }}>
                {label}
              </button>
            ))}
            <select
              onMouseDown={e => {
                // Save selection before the select steals focus
                const sel = window.getSelection();
                if (sel && sel.rangeCount > 0) savedSelectionRef.current = sel.getRangeAt(0).cloneRange();
              }}
              onChange={e => {
                const size = e.target.value;
                e.target.value = "";
                if (!size) return;
                editorRef.current?.focus();
                const sel = window.getSelection();
                if (sel && savedSelectionRef.current) {
                  sel.removeAllRanges();
                  sel.addRange(savedSelectionRef.current);
                }
                document.execCommand("fontSize", false, size);
                setReplyText(editorRef.current?.innerHTML || '');
              }}
              style={{ padding:"2px 6px", borderRadius:4, border:`1px solid ${COLORS.border}`, fontSize:11, cursor:"pointer" }}>
              <option value="">Size</option>
              <option value="1">Small</option>
              <option value="3">Normal</option>
              <option value="5">Large</option>
              <option value="7">X-Large</option>
            </select>
            {[["#000000","Black"],["#e84949","Red"],["#16a34a","Green"],["#4f6ef7","Blue"]].map(([color,name])=>(
              <button key={color}
                onMouseDown={e => {
                  e.preventDefault();
                  editorRef.current?.focus();
                  const sel = window.getSelection();
                  if (sel && savedSelectionRef.current) {
                    sel.removeAllRanges();
                    sel.addRange(savedSelectionRef.current);
                  }
                  document.execCommand("foreColor", false, color);
                  setReplyText(editorRef.current?.innerHTML || '');
                }}
                title={name}
                style={{ width:20, height:20, borderRadius:"50%", background:color, border:"2px solid #fff", cursor:"pointer", boxShadow:`0 0 0 1px ${COLORS.border}` }}/>
            ))}
          </div>

          
          {/* Editor */}
          <div style={{ position:'relative' }}>
          <div
            ref={editorRef}
            contentEditable={true}
            suppressContentEditableWarning={true}
            onInput={e => setReplyText(e.currentTarget.innerHTML)}
            onKeyUp={() => {
  const sel = window.getSelection();
  if (sel && sel.rangeCount > 0) savedSelectionRef.current = sel.getRangeAt(0).cloneRange();
  handleMentionKeyUp();
}}
            onMouseUp={() => {
              const sel = window.getSelection();
              if (sel && sel.rangeCount > 0) savedSelectionRef.current = sel.getRangeAt(0).cloneRange();
            }}
            onPaste={e => {
              const items = e.clipboardData?.items;
              if (!items) return;
              // Handle image paste
              for (let i = 0; i < items.length; i++) {
                if (items[i].type.startsWith('image/')) {
                  e.preventDefault();
                  const file = items[i].getAsFile();
                  if (!file) continue;
                  const reader = new FileReader();
                  reader.onload = ev => {
                    const img = document.createElement('img');
                    img.src = ev.target.result;
                    img.style.cssText = 'max-width:100%;min-width:400px;height:auto;display:block;margin:4px 0;';
                    const sel = window.getSelection();
                    if (sel && sel.rangeCount > 0) {
                      const range = sel.getRangeAt(0);
                      range.deleteContents();
                      range.insertNode(img);
                      range.setStartAfter(img);
                      range.collapse(true);
                      sel.removeAllRanges();
                      sel.addRange(range);
                    } else if (editorRef.current) {
                      editorRef.current.appendChild(img);
                    }
                    setReplyText(editorRef.current?.innerHTML || '');
                  };
                  reader.readAsDataURL(file);
                  return;
                }
              }
              // Handle HTML paste (preserve tables)
              const html = e.clipboardData.getData('text/html');
              if (html && html.includes('<table')) {
                e.preventDefault();
                const sel = window.getSelection();
                if (sel && sel.rangeCount > 0) {
                  const range = sel.getRangeAt(0);
                  range.deleteContents();
                  const div = document.createElement('div');
                  div.innerHTML = html;
                  div.querySelectorAll('table').forEach(t => { t.style.cssText = 'border-collapse:collapse;width:100%;margin:8px 0;'; });
                  div.querySelectorAll('td,th').forEach(td => { td.style.cssText = 'border:1px solid #d1d5db;padding:6px 10px;font-size:12px;'; });
                  const frag = document.createDocumentFragment();
                  while (div.firstChild) frag.appendChild(div.firstChild);
                  range.insertNode(frag);
                  range.collapse(false);
                  sel.removeAllRanges();
                  sel.addRange(range);
                }
                setReplyText(editorRef.current?.innerHTML || '');
              }
            }}
            onDragOver={e=>{ e.preventDefault(); e.currentTarget.style.border=`2px dashed ${COLORS.accent}`; }}
            onDragLeave={e=>{ e.currentTarget.style.border=`1px solid ${COLORS.border}`; }}
            onDrop={e=>{
              e.preventDefault();
              e.currentTarget.style.border=`1px solid ${COLORS.border}`;
              const files = Array.from(e.dataTransfer.files);
              if (files.length) setAttachments(prev=>[...prev,...files]);
            }}
            data-placeholder="Type your reply here... (drag & drop files here)"
          style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:"0 0 8px 8px", padding:"10px 12px", fontSize:12, outline:"none", minHeight:200, fontFamily:"system-ui,sans-serif", boxSizing:"border-box", color:COLORS.text, marginBottom:8, overflowY:"auto" }}
          />
          {MentionDropdown}
          </div>

          {/* Attachment chips */}
          {attachments.length > 0 && (
            <div style={{ marginBottom:8, display:"flex", flexWrap:"wrap", gap:4 }}>
              {attachments.map(f=>(
                <span key={f.name} style={{ display:"flex", alignItems:"center", gap:4, background:COLORS.bg, border:`1px solid ${COLORS.border}`, padding:"2px 8px", borderRadius:99, fontSize:11, color:COLORS.text }}>
                  {f.type && f.type.startsWith('image/') ? '🖼️' : '📎'} {f.name}
                  <button onClick={()=>removeAttachment(f.name)} style={{ background:"none", border:"none", cursor:"pointer", color:COLORS.vip, fontSize:12, padding:0 }}>×</button>
                </span>
              ))}
            </div>
          )}

          {/* Footer */}
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <button onClick={()=>fileRef.current?.click()} style={{ padding:"6px 12px", border:`1px solid ${COLORS.border}`, background:"transparent", color:COLORS.textMuted, borderRadius:8, fontSize:11, cursor:"pointer" }}>
              📎 Attach File
            </button>
            <input ref={fileRef} type="file" multiple onChange={handleFileChange} style={{ display:"none" }}/>
            <div style={{ display:"flex", gap:8 }}>
              <button onClick={cancel} style={{ padding:"7px 14px", borderRadius:8, border:`1px solid ${COLORS.border}`, background:"transparent", color:COLORS.textMuted, fontSize:12, cursor:"pointer" }}>Cancel</button>
              <button onClick={send} disabled={sending}
                style={{ padding:"7px 20px", borderRadius:8, border:"none", background:sending?COLORS.textLight:COLORS.accent, color:"#fff", fontSize:12, fontWeight:600, cursor:sending?"not-allowed":"pointer" }}>
                {sending ? "Sending..." : "Send Reply →"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── DropdownActions ───────────────────────────────────────────────────────────
function DropdownActions({ ticket, updateTicket, showToast, properties=[], isPrivileged=false }) {
  const [open, setOpen] = useState(false);
  const [propSearch, setPropSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const filteredProps = propSearch ? properties.filter(p => p.name.toLowerCase().includes(propSearch.toLowerCase())).slice(0,10) : [];

  return (
    <div ref={ref} style={{ position:"relative" }}>
      <button onClick={()=>setOpen(p=>!p)} style={{ padding:"7px 14px", borderRadius:8, border:`1px solid ${COLORS.border}`, background:COLORS.cardBg, color:COLORS.text, fontSize:12, cursor:"pointer", fontWeight:500, display:"flex", alignItems:"center", gap:6 }}>
        ⚙ Actions {open ? "▲" : "▼"}
      </button>
      {open && (
        <div style={{ position:"absolute", top:"calc(100% + 8px)", right:0, width:380, background:COLORS.cardBg, border:`1px solid ${COLORS.border}`, borderRadius:12, boxShadow:"0 8px 32px rgba(0,0,0,.15)", zIndex:300, padding:16 }}>
          <div style={{ fontSize:12, fontWeight:600, color:COLORS.text, marginBottom:12 }}>Update Ticket</div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:12 }}>
            {[["Status",STATUSES,"status"],["Bucket",["RP","YARDI","Unassigned"],"bucket"],...(isPrivileged?[["Assigned",AGENTS,"assignedTo"]]:[])].map(([lbl,opts,key])=>(
              <div key={key}>
                <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:3 }}>{lbl}</div>
                <select
                  value={key==="assignedTo"?(Array.isArray(ticket.assignedTo)?ticket.assignedTo[0]:ticket.assignedTo):ticket[key]}
                  onChange={e=>updateTicket(ticket.id, key==="assignedTo" ? {assignedTo:[e.target.value], assigned_to:e.target.value} : {[key]:e.target.value})}
                  style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"5px 6px", fontSize:11, background:COLORS.bg, color:COLORS.text, outline:"none" }}>
                  {opts.map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
            ))}
          </div>
          <div style={{ marginBottom:12 }}>
            <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:3 }}>🏢 Update Property</div>
            <input value={propSearch} onChange={e=>setPropSearch(e.target.value)} placeholder="Search property..."
              style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"5px 8px", fontSize:11, background:COLORS.bg, color:COLORS.text, outline:"none", boxSizing:"border-box" }}/>
            {filteredProps.length > 0 && (
              <div style={{ border:`1px solid ${COLORS.border}`, borderRadius:8, marginTop:4, maxHeight:120, overflowY:"auto", background:COLORS.cardBg }}>
                {filteredProps.map(p=>(
                  <div key={p.id} onClick={()=>{ updateTicket(ticket.id,{bucket:p.bucket}); showToast(`Property set: ${p.name}`); setPropSearch(''); setOpen(false); }}
                    style={{ padding:"6px 10px", fontSize:11, cursor:"pointer", color:COLORS.text, borderBottom:`1px solid ${COLORS.border}` }}
                    onMouseEnter={e=>e.currentTarget.style.background=COLORS.bg}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    {p.name} <span style={{ color:COLORS.textMuted }}>({p.bucket})</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
            <button onClick={()=>{ updateTicket(ticket.id,{isVIP:!ticket.isVIP, is_vip:ticket.isVIP?0:1}); setOpen(false); }} style={{ padding:"6px 12px", borderRadius:8, border:`1px solid ${ticket.isVIP?COLORS.vip:COLORS.border}`, background:ticket.isVIP?COLORS.vipLight:"transparent", color:ticket.isVIP?COLORS.vip:COLORS.textMuted, fontSize:11, cursor:"pointer" }}>{ticket.isVIP?"Remove VIP":"⚡ VIP"}</button>
            <button onClick={()=>{ updateTicket(ticket.id,{status:"In Progress"}); showToast("In Progress!"); setOpen(false); }} style={{ padding:"6px 12px", borderRadius:8, border:`1px solid ${COLORS.warning}`, background:COLORS.warningLight, color:COLORS.warning, fontSize:11, cursor:"pointer" }}>◑ In Progress</button>
            <button onClick={()=>{ updateTicket(ticket.id,{status:"On Hold"}); showToast("On Hold!"); setOpen(false); }} style={{ padding:"6px 12px", borderRadius:8, border:"1px solid #9333ea", background:"#f3e8ff", color:"#9333ea", fontSize:11, cursor:"pointer" }}>⏸ On Hold</button>
            <button onClick={()=>{ updateTicket(ticket.id,{status:"Escalated"}); showToast("Escalated!"); setOpen(false); }} style={{ padding:"6px 12px", borderRadius:8, border:`1px solid ${COLORS.vip}`, background:COLORS.vipLight, color:COLORS.vip, fontSize:11, cursor:"pointer" }}>⚡ Escalate</button>
            <button onClick={()=>{ updateTicket(ticket.id,{status:"Closed"}); showToast("Closed."); setOpen(false); }} style={{ padding:"6px 12px", borderRadius:8, border:`1px solid ${COLORS.border}`, background:"transparent", color:COLORS.textMuted, fontSize:11, cursor:"pointer" }}>✕ Close</button>
            <button onClick={()=>{ updateTicket(ticket.id,{status:"No Action Required"}); showToast("No Action Required."); setOpen(false); }} style={{ padding:"6px 12px", borderRadius:8, border:"1px solid #64748b", background:"#f1f5f9", color:"#64748b", fontSize:11, cursor:"pointer" }}>— No Action Required</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── UsersPage ─────────────────────────────────────────────────────────────────
function UsersPage() {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form, setForm] = useState({ name:"", email:"", password:"", role:"Agent", status:"Active" });
  const [toast, setToast] = useState("");
  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(""),3000); };

  const fetchUsers = async () => {
    try { const res=await fetch(`${API}/users`); const data=await res.json(); setUsers(Array.isArray(data)?data:[]); } catch(e) { setUsers([]); }
  };
  useEffect(()=>{ fetchUsers(); },[]);

  const openAdd = () => { setForm({ name:"", email:"", password:"", role:"Agent", status:"Active" }); setEditUser(null); setShowModal(true); };
  const openEdit = u => { setForm({ name:u.name, email:u.email, password:"", role:u.role, status:u.status }); setEditUser(u); setShowModal(true); };

  const saveUser = async () => {
    if (!form.name||!form.email) return showToast("Fill all fields");
    if (!form.email.includes('@')) return showToast("Enter a valid email!");
    try {
      if (editUser) {
        await fetch(`${API}/users/${editUser.id}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
        showToast("User updated!");
      } else {
        if (!form.password) return showToast("Password required!");
        await fetch(`${API}/users`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
        showToast("User added!");
      }
      fetchUsers();
    } catch(e) { showToast("Error: "+e.message); }
    setShowModal(false);
  };

  const toggleStatus = async u => {
    try { await fetch(`${API}/users/${u.id}/toggle-status`,{method:'PATCH'}); fetchUsers(); showToast(`User ${u.status==="Active"?"deactivated":"activated"}!`); } catch(e) { showToast("Error"); }
  };

  return (
    <div>
      {toast&&<div style={{position:"fixed",top:16,right:16,zIndex:999,background:"#1e1f2e",color:"#fff",padding:"10px 16px",borderRadius:8,fontSize:12}}>{toast}</div>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontSize:14,fontWeight:500,color:COLORS.text}}>All Users ({users.length})</div>
        <button onClick={openAdd} style={{background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:500,cursor:"pointer"}}>+ Add User</button>
      </div>
      <Card>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead><tr style={{background:COLORS.bg,borderBottom:`1px solid ${COLORS.border}`}}>{["Name","Email","Role","Status","Actions"].map(h=><th key={h} style={{padding:"10px 16px",textAlign:"left",fontWeight:500,color:COLORS.textMuted,fontSize:12}}>{h}</th>)}</tr></thead>
          <tbody>
            {users.map(u=>(
              <tr key={u.id} style={{borderBottom:`1px solid ${COLORS.border}`}}>
                <td style={{padding:"12px 16px"}}><div style={{display:"flex",alignItems:"center",gap:10}}><Avatar name={u.name} size={32} color={COLORS.accent}/><span style={{fontWeight:500,color:COLORS.text}}>{u.name}</span></div></td>
                <td style={{padding:"12px 16px",color:COLORS.textMuted}}>{u.email}</td>
                <td style={{padding:"12px 16px"}}><Badge label={u.role} color={u.role==="Admin"?COLORS.vip:u.role==="Manager"?"#7c3aed":u.role==="TL"?COLORS.warning:COLORS.accent} bg={u.role==="Admin"?COLORS.vipLight:u.role==="Manager"?"#f3e8ff":u.role==="TL"?COLORS.warningLight:COLORS.accentLight}/></td>
                <td style={{padding:"12px 16px"}}><Badge label={u.status} color={u.status==="Active"?COLORS.success:COLORS.textMuted} bg={u.status==="Active"?COLORS.successLight:"#f3f4f6"}/></td>
                <td style={{padding:"12px 16px"}}><div style={{display:"flex",gap:8}}>
                  <button onClick={()=>openEdit(u)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.accent,fontSize:11,cursor:"pointer"}}>Edit</button>
                  <button onClick={()=>toggleStatus(u)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:u.status==="Active"?COLORS.vip:COLORS.success,fontSize:11,cursor:"pointer"}}>{u.status==="Active"?"Deactivate":"Activate"}</button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      {showModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50}}>
          <Card style={{width:420,padding:24}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontWeight:500,fontSize:15,color:COLORS.text}}>{editUser?"Edit User":"Add New User"}</div>
              <button onClick={()=>setShowModal(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:COLORS.textMuted}}>×</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {[["Name","name","text","Full name"],["Email","email","email","email@enhancor.com"],["Password","password","password","Min 6 characters"]].map(([l,k,t,ph])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><input type={t} value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,outline:"none",boxSizing:"border-box",background:COLORS.bg,color:COLORS.text}}/></div>
              ))}
              {[["Role","role",["Admin","Manager","TL","Agent"]],["Status","status",["Active","Inactive"]]].map(([l,k,opts])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><select value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,background:COLORS.bg,color:COLORS.text,outline:"none"}}>{opts.map(o=><option key={o}>{o}</option>)}</select></div>
              ))}
              <div style={{display:"flex",gap:8,paddingTop:4}}>
                <button onClick={()=>setShowModal(false)} style={{flex:1,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer"}}>Cancel</button>
                <button onClick={saveUser} style={{flex:1,background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px",fontSize:12,fontWeight:500,cursor:"pointer"}}>Save</button>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

// ── PropertiesPage ────────────────────────────────────────────────────────────
function PropertiesPage() {
  const [properties, setProperties] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showBulk, setShowBulk] = useState(false);
  const [editProp, setEditProp] = useState(null);
  const [form, setForm] = useState({ name:"", bucket:"RP", address:"", status:"Active" });
  const [toast, setToast] = useState("");
  const [filterBucket, setFilterBucket] = useState("All");
  const [csvData, setCsvData] = useState([]);
  const [csvError, setCsvError] = useState("");
  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(""),3000); };

  const fetchProperties = async () => {
    try {
      const url = filterBucket==="All" ? `${API}/properties` : `${API}/properties?bucket=${filterBucket}`;
      const res = await fetch(url);
      const data = await res.json();
      // Only use API data; don't silently fall back to fake data
      setProperties(Array.isArray(data) ? data : []);
    } catch(e) { setProperties([]); }
  };
  useEffect(()=>{ fetchProperties(); },[filterBucket]);

  const openAdd = () => { setForm({ name:"", bucket:"RP", address:"", status:"Active" }); setEditProp(null); setShowModal(true); };
  const openEdit = p => { setForm({ name:p.name, bucket:p.bucket, address:p.address, status:p.status }); setEditProp(p); setShowModal(true); };

  const saveProp = async () => {
    if (!form.name||!form.address) return showToast("Fill all fields");
    try {
      if (editProp) {
        await fetch(`${API}/properties/${editProp.id}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
        showToast("Property updated!");
      } else {
        await fetch(`${API}/properties`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
        showToast("Property added!");
      }
      fetchProperties();
    } catch(e) { showToast("Error: "+e.message); }
    setShowModal(false);
  };

  const toggleStatus = async p => {
    try { await fetch(`${API}/properties/${p.id}/toggle-status`,{method:'PATCH'}); fetchProperties(); showToast(`Property ${p.status==="Active"?"deactivated":"activated"}!`); } catch(e) { showToast("Error"); }
  };

  const handleCSV = (e) => {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const lines = ev.target.result.split('\n').filter(l=>l.trim());
      const headers = lines[0].toLowerCase().split(',').map(h=>h.trim());
      const nameIdx=headers.indexOf('name'), bucketIdx=headers.indexOf('bucket'), addressIdx=headers.indexOf('address');
      if (nameIdx===-1||bucketIdx===-1) { setCsvError("CSV must have 'name' and 'bucket' columns!"); return; }
      const rows = lines.slice(1).map(line=>{
        const cols = line.split(',').map(c=>c.trim());
        return { name:cols[nameIdx]||'', bucket:cols[bucketIdx]||'RP', address:addressIdx!==-1?cols[addressIdx]||'':'', status:'Active' };
      }).filter(r=>r.name);
      setCsvData(rows); setCsvError("");
    };
    reader.readAsText(file);
  };

  const uploadBulk = async () => {
    if (!csvData.length) return showToast("No data!");
    let success = 0;
    for (const prop of csvData) {
      try { await fetch(`${API}/properties`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(prop)}); success++; } catch(e) {}
    }
    showToast(`${success} properties added!`); setShowBulk(false); setCsvData([]); fetchProperties();
  };

  return (
    <div>
      {toast&&<div style={{position:"fixed",top:16,right:16,zIndex:999,background:"#1e1f2e",color:"#fff",padding:"10px 16px",borderRadius:8,fontSize:12}}>{toast}</div>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{fontSize:14,fontWeight:500,color:COLORS.text}}>All Properties ({properties.length})</div>
          <select value={filterBucket} onChange={e=>setFilterBucket(e.target.value)} style={{border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"6px 10px",fontSize:12,background:COLORS.bg,color:COLORS.text,outline:"none"}}>{["All","RP","YARDI"].map(o=><option key={o}>{o}</option>)}</select>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={openAdd} style={{background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:500,cursor:"pointer"}}>+ Add Property</button>
          <button onClick={()=>{setShowBulk(true);setCsvData([]);setCsvError("");}} style={{background:COLORS.success,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:500,cursor:"pointer"}}>⬆ Bulk Upload</button>
        </div>
      </div>
      <Card>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead><tr style={{background:COLORS.bg,borderBottom:`1px solid ${COLORS.border}`}}>{["Name","Bucket","Property Code","Status","Actions"].map(h=><th key={h} style={{padding:"10px 16px",textAlign:"left",fontWeight:500,color:COLORS.textMuted,fontSize:12}}>{h}</th>)}</tr></thead>
          <tbody>
            {properties.length === 0 && (
              <tr><td colSpan={5} style={{padding:24,textAlign:"center",color:COLORS.textMuted,fontSize:12}}>No properties found</td></tr>
            )}
            {properties.map(p=>(
              <tr key={p.id} style={{borderBottom:`1px solid ${COLORS.border}`}}>
                <td style={{padding:"12px 16px",fontWeight:500,color:COLORS.text}}>{p.name}</td>
                <td style={{padding:"12px 16px"}}>{bucketBadge(p.bucket)}</td>
                <td style={{padding:"12px 16px",color:COLORS.textMuted}}>{p.address}</td>
                <td style={{padding:"12px 16px"}}><Badge label={p.status} color={p.status==="Active"?COLORS.success:COLORS.textMuted} bg={p.status==="Active"?COLORS.successLight:"#f3f4f6"}/></td>
                <td style={{padding:"12px 16px"}}><div style={{display:"flex",gap:8}}>
                  <button onClick={()=>openEdit(p)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.accent,fontSize:11,cursor:"pointer"}}>Edit</button>
                  <button onClick={()=>toggleStatus(p)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:p.status==="Active"?COLORS.vip:COLORS.success,fontSize:11,cursor:"pointer"}}>{p.status==="Active"?"Deactivate":"Activate"}</button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      {showModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50}}>
          <Card style={{width:420,padding:24}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontWeight:500,fontSize:15,color:COLORS.text}}>{editProp?"Edit Property":"Add New Property"}</div>
              <button onClick={()=>setShowModal(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:COLORS.textMuted}}>×</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {[["Name","name","text","Property name"],["Property Code","address","text","e.g. b3621"]].map(([l,k,t,ph])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><input type={t} value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,outline:"none",boxSizing:"border-box",background:COLORS.bg,color:COLORS.text}}/></div>
              ))}
              {[["Bucket","bucket",["RP","YARDI"]],["Status","status",["Active","Inactive"]]].map(([l,k,opts])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><select value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,background:COLORS.bg,color:COLORS.text,outline:"none"}}>{opts.map(o=><option key={o}>{o}</option>)}</select></div>
              ))}
              <div style={{display:"flex",gap:8,paddingTop:4}}>
                <button onClick={()=>setShowModal(false)} style={{flex:1,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer"}}>Cancel</button>
                <button onClick={saveProp} style={{flex:1,background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px",fontSize:12,fontWeight:500,cursor:"pointer"}}>Save</button>
              </div>
            </div>
          </Card>
        </div>
      )}
      {showBulk&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50}}>
          <Card style={{width:520,padding:24}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontWeight:500,fontSize:15,color:COLORS.text}}>Bulk Upload Properties</div>
              <button onClick={()=>setShowBulk(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:COLORS.textMuted}}>×</button>
            </div>
            <div style={{background:COLORS.bg,borderRadius:8,padding:12,marginBottom:14,fontSize:12,color:COLORS.textMuted}}>
              <div style={{fontWeight:500,color:COLORS.text,marginBottom:6}}>CSV Format:</div>
              <code style={{fontSize:11,display:"block"}}>name,bucket,address</code>
              <code style={{fontSize:11,display:"block"}}>Camden Property,RP,123 Main St New York</code>
            </div>
            <div style={{marginBottom:14}}>
              <div style={{fontSize:12,color:COLORS.textMuted,marginBottom:6}}>Select CSV file:</div>
              <input type="file" accept=".csv" onChange={handleCSV} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px",fontSize:12,background:COLORS.bg}}/>
            </div>
            {csvError&&<div style={{fontSize:12,color:COLORS.vip,background:COLORS.vipLight,padding:"8px 12px",borderRadius:8,marginBottom:14}}>{csvError}</div>}
            {csvData.length>0&&(
              <div style={{marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:500,color:COLORS.text,marginBottom:8}}>Preview ({csvData.length} properties):</div>
                <div style={{maxHeight:160,overflowY:"auto",border:`1px solid ${COLORS.border}`,borderRadius:8}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
                    <thead><tr style={{background:COLORS.bg}}>{["Name","Bucket","Property Code"].map(h=><th key={h} style={{padding:"6px 10px",textAlign:"left",color:COLORS.textMuted}}>{h}</th>)}</tr></thead>
                    <tbody>{csvData.map((p,i)=><tr key={i} style={{borderTop:`1px solid ${COLORS.border}`}}><td style={{padding:"6px 10px",color:COLORS.text}}>{p.name}</td><td style={{padding:"6px 10px"}}>{bucketBadge(p.bucket)}</td><td style={{padding:"6px 10px",color:COLORS.textMuted}}>{p.address}</td></tr>)}</tbody>
                  </table>
                </div>
              </div>
            )}
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setShowBulk(false)} style={{flex:1,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer"}}>Cancel</button>
              <button onClick={uploadBulk} disabled={!csvData.length} style={{flex:1,background:csvData.length?COLORS.success:COLORS.border,color:"#fff",border:"none",borderRadius:8,padding:"8px",fontSize:12,fontWeight:500,cursor:csvData.length?"pointer":"not-allowed"}}>Upload {csvData.length>0?`(${csvData.length})`:''}</button>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

// ── ReportsPage ───────────────────────────────────────────────────────────────
function ReportsPage({ user, onTicketClick }) {
  const isPrivileged = user?.role === "Admin" || user?.role === "Manager" || user?.role === "TL";
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [apiPage, setApiPage] = useState(1);
  const [apiLastPage, setApiLastPage] = useState(1);
  const today = new Date();
  const sevenDaysAgo = new Date(); sevenDaysAgo.setDate(today.getDate() - 6);
  const toInputVal = d => d.toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(toInputVal(sevenDaysAgo));
  const [endDate, setEndDate] = useState(toInputVal(today));
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterBucket, setFilterBucket] = useState("All");
  const [filterCategory, setFilterCategory] = useState("All");
  const [filterAgent, setFilterAgent] = useState(() => isPrivileged ? "All" : (user?.name || "All"));
  const [filterInbox, setFilterInbox] = useState("All");
  const [filterProperty, setFilterProperty] = useState("All");
  const [properties, setProperties] = useState([]);
  const [searchTable, setSearchTable] = useState("");
  const [exporting, setExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState("");
  const [pendingSearch, setPendingSearch] = useState("");
  const [sortField, setSortField] = useState("date");
  const [sortDir, setSortDir] = useState("desc");
  const searchTimer = useRef(null);

  useEffect(() => {
    fetch(`${API}/properties`).then(r=>r.json()).then(d=>setProperties(Array.isArray(d)?d:[])).catch(()=>{});
  }, []);

  const fetchReportTickets = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ per_page: 50, page });
      if (filterStatus !== "All")   params.append('status', filterStatus);
      if (filterBucket !== "All")   params.append('bucket', filterBucket);
      if (filterAgent !== "All")    params.append('agent', filterAgent);
      else if (!isPrivileged && user?.name) params.append('agent', user.name);
      if (filterCategory !== "All") params.append('category', filterCategory);
      if (filterInbox !== "All")    params.append('inbox', filterInbox);
      if (filterProperty !== "All") params.append('property', filterProperty);
      if (searchTable)              params.append('search', searchTable);
      if (startDate)                params.append('start_date', startDate);
      if (endDate)                  params.append('end_date', endDate);
      const res = await fetch(`${API}/tickets?${params}`);
      const data = await res.json();
      const mapped = (data.data||[]).map(t => ({
        ...t,
        assignedTo: t.assigned_to ? t.assigned_to.split(',') : ['Unassigned'],
        isVIP: t.is_vip === 1 || t.is_vip === true,
        date: t.created_at,
      }));
      setTickets(mapped);
      setTotalCount(data.total || 0);
      setApiPage(data.current_page || 1);
      setApiLastPage(data.last_page || 1);
    } catch(e) { console.error("Reports fetch error:", e); }
    setLoading(false);
  }, [filterStatus, filterBucket, filterAgent, filterCategory, filterInbox, filterProperty, searchTable, startDate, endDate, isPrivileged, user?.name]);

  useEffect(() => { fetchReportTickets(1); }, [filterStatus, filterBucket, filterAgent, filterCategory, filterInbox, filterProperty, startDate, endDate]);

  useEffect(() => {
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => { setSearchTable(pendingSearch); }, 500);
    return () => clearTimeout(searchTimer.current);
  }, [pendingSearch]);

  useEffect(() => { fetchReportTickets(1); }, [searchTable]);

  // Client-side sort applied on top of what the API returns
  const sortedTickets = useMemo(() => {
    const sorted = [...tickets].sort((a, b) => {
      let av = a[sortField] ?? '';
      let bv = b[sortField] ?? '';
      if (sortField === 'date') { av = new Date(av); bv = new Date(bv); }
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [tickets, sortField, sortDir]);

  const clearFilters = () => {
    setStartDate(toInputVal(sevenDaysAgo)); setEndDate(toInputVal(today));
    setFilterStatus("All"); setFilterBucket("All"); setFilterCategory("All");
    setFilterAgent(isPrivileged ? "All" : (user?.name || "All"));
    setFilterInbox("All"); setFilterProperty("All");
    setPendingSearch(""); setSearchTable("");
  };

  const exportCSV = async () => {
    setExporting(true);
    setExportProgress("Starting...");
    try {
      let allTickets = [];
      let pg = 1;
      let lastPg = 1;
      do {
        setExportProgress(`Page ${pg} of ${lastPg}...`);
        const params = new URLSearchParams({ per_page: 500, page: pg });
        if (filterStatus !== "All")   params.append("status", filterStatus);
        if (filterBucket !== "All")   params.append("bucket", filterBucket);
        if (filterAgent !== "All")    params.append("agent", filterAgent);
        else if (!isPrivileged && user?.name) params.append("agent", user.name);
        if (filterCategory !== "All") params.append("category", filterCategory);
        if (filterInbox !== "All")    params.append("inbox", filterInbox);
        if (filterProperty !== "All") params.append("property", filterProperty);
        if (searchTable)              params.append("search", searchTable);
        if (startDate)                params.append("start_date", startDate);
        if (endDate)                  params.append("end_date", endDate);
        const res = await fetch(`${API}/tickets?${params}`);
        const data = await res.json();
        const mapped = (data.data||[]).map(t => ({...t, assignedTo: t.assigned_to ? t.assigned_to.split(",") : ["Unassigned"], isVIP: t.is_vip===1||t.is_vip===true, date: t.created_at}));
        allTickets = [...allTickets, ...mapped];
        lastPg = data.last_page || 1;
        setExportProgress(`Fetched ${allTickets.length} of ${data.total} tickets...`);
        pg++;
      } while (pg <= lastPg);
      setExportProgress("Generating CSV...");
      const headers = ["ID","Subject","From","To","Status","Bucket","Category","Assigned To","Created Date"];
      const rows = allTickets.map(t => [t.id,`"${(t.subject||"").replace(/"/g,'""')}"`,t.from,t.to,t.status,t.bucket,t.category,Array.isArray(t.assignedTo)?t.assignedTo.join(";"):t.assignedTo,formatISTDate(t.date)]);
      const csv = [headers,...rows].map(r=>r.join(",")).join("\n");
      const blob = new Blob([csv],{type:"text/csv"});
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href=url; a.download=`tickets_report_${new Date().toISOString().split("T")[0]}.csv`;
      a.click(); URL.revokeObjectURL(url);
      setExportProgress("");
    } catch(e) { console.error("Export error:", e); setExportProgress(""); }
    setExporting(false);
  };

  const rangeLabelStr = useMemo(() => {
    const fmt = d => new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
    if (startDate && endDate) return `${fmt(startDate)} – ${fmt(endDate)}`;
    return "All time";
  }, [startDate, endDate]);

  const C = COLORS;
  const fieldStyle = { width:"100%", border:`1px solid ${C.border}`, borderRadius:8, padding:"8px 10px", fontSize:12, background:C.cardBg, color:C.text, outline:"none", boxSizing:"border-box" };
  const selectWrap = { position:"relative" };
  const chevron = { position:"absolute", right:10, top:"50%", transform:"translateY(-50%)", pointerEvents:"none", fontSize:10, color:C.textMuted };
  const statusColors = { Open:C.accent,"In Progress":C.warning,"On Hold":"#9333ea",Escalated:C.vip,Closed:C.textMuted,Resolved:C.success };
  const statusBg = { Open:C.accentLight,"In Progress":C.warningLight,"On Hold":"#f3e8ff",Escalated:C.vipLight,Closed:"#f3f4f6",Resolved:C.successLight };

  return (
    <div style={{ fontFamily:"system-ui,sans-serif", color:C.text }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <div style={{ fontSize:20, fontWeight:600, color:C.text }}>Ticket Reports</div>
          <div style={{ fontSize:12, color:C.textMuted, marginTop:3 }}>{totalCount.toLocaleString()} tickets · {rangeLabelStr}{loading && " · Loading..."}</div>
        </div>
        <button onClick={exportCSV} disabled={exporting} style={{ padding:"8px 16px", background:C.success, color:"#fff", border:"none", borderRadius:8, fontSize:12, fontWeight:500, cursor:"pointer" }}>
          {exporting ? (exportProgress || "Exporting...") : "⬇ Export CSV"}
        </button>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:10, marginBottom:20 }}>
        {[["Total",totalCount,C.text],["Open",tickets.filter(t=>t.status==="Open").length,C.accent],["Closed",tickets.filter(t=>t.status==="Closed").length,C.success],["Escalated",tickets.filter(t=>t.status==="Escalated").length,C.vip],["VIP",tickets.filter(t=>t.isVIP).length,C.warning]].map(([l,v,c])=>(
          <div key={l} style={{ background:C.cardBg, border:`1px solid ${C.border}`, borderTop:`3px solid ${c}`, borderRadius:12, padding:"14px 16px" }}>
            <div style={{ fontSize:24, fontWeight:700, color:c }}>{v.toLocaleString()}</div>
            <div style={{ fontSize:11, color:C.textMuted, marginTop:4 }}>{l}</div>
          </div>
        ))}
      </div>
      <div style={{ background:C.cardBg, border:`1px solid ${C.border}`, borderRadius:12, padding:"20px 24px 24px", marginBottom:20 }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"16px 20px", marginBottom:16 }}>
          <div><div style={{ fontSize:12, color:C.textMuted, fontWeight:500, marginBottom:6 }}>Inbox</div><div style={selectWrap}><select value={filterInbox} onChange={e=>setFilterInbox(e.target.value)} style={{ ...fieldStyle, paddingRight:28, appearance:"none" }}><option value="All">All Inboxes</option>{INBOXES.map(i=><option key={i}>{i}</option>)}</select><span style={chevron}>▼</span></div></div>
          {isPrivileged && <div><div style={{ fontSize:12, color:C.textMuted, fontWeight:500, marginBottom:6 }}>Agent</div><div style={selectWrap}><select value={filterAgent} onChange={e=>setFilterAgent(e.target.value)} style={{ ...fieldStyle, paddingRight:28, appearance:"none" }}><option value="All">All Agents</option>{AGENTS.map(a=><option key={a}>{a}</option>)}</select><span style={chevron}>▼</span></div></div>}
          <div><div style={{ fontSize:12, color:C.textMuted, fontWeight:500, marginBottom:6 }}>Status</div><div style={selectWrap}><select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{ ...fieldStyle, paddingRight:28, appearance:"none" }}><option value="All">All Statuses</option>{STATUSES.map(s=><option key={s}>{s}</option>)}</select><span style={chevron}>▼</span></div></div>
          <div><div style={{ fontSize:12, color:C.textMuted, fontWeight:500, marginBottom:6 }}>Category</div><div style={selectWrap}><select value={filterCategory} onChange={e=>setFilterCategory(e.target.value)} style={{ ...fieldStyle, paddingRight:28, appearance:"none" }}><option value="All">All Categories</option>{CATEGORIES.map(c=><option key={c}>{c}</option>)}</select><span style={chevron}>▼</span></div></div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"16px 20px", alignItems:"flex-end" }}>
          <div><div style={{ fontSize:12, color:C.textMuted, fontWeight:500, marginBottom:6 }}>Property</div><div style={selectWrap}><select value={filterProperty} onChange={e=>setFilterProperty(e.target.value)} style={{ ...fieldStyle, paddingRight:28, appearance:"none" }}><option value="All">All Properties</option>{properties.map(p=><option key={p.id} value={p.name}>{p.name}</option>)}</select><span style={chevron}>▼</span></div></div>
          <div><div style={{ fontSize:12, color:C.textMuted, fontWeight:500, marginBottom:6 }}>Start Date</div><input type="date" value={startDate} onChange={e=>setStartDate(e.target.value)} style={{ ...fieldStyle, cursor:"pointer" }}/></div>
          <div><div style={{ fontSize:12, color:C.textMuted, fontWeight:500, marginBottom:6 }}>End Date</div><input type="date" value={endDate} onChange={e=>setEndDate(e.target.value)} min={startDate} style={{ ...fieldStyle, cursor:"pointer" }}/></div>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={clearFilters} style={{ flex:1, padding:"8px 12px", fontSize:12, border:`1px solid ${C.border}`, borderRadius:8, background:"transparent", color:C.textMuted, cursor:"pointer" }}>Clear</button>
            <button onClick={()=>fetchReportTickets(1)} style={{ flex:1, padding:"8px 12px", fontSize:12, border:"none", borderRadius:8, background:C.accent, color:"#fff", cursor:"pointer", fontWeight:500 }}>Apply</button>
          </div>
        </div>
      </div>
      <div style={{ background:C.cardBg, border:`1px solid ${C.border}`, borderRadius:12, padding:20 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14, flexWrap:"wrap", gap:8 }}>
          <div style={{ fontWeight:500, fontSize:13, color:C.text }}>Ticket details ({totalCount.toLocaleString()})</div>
          <input value={pendingSearch} onChange={e=>setPendingSearch(e.target.value)} placeholder="Search by subject, sender, ID..." style={{ border:`1px solid ${C.border}`, borderRadius:8, padding:"6px 12px", fontSize:12, outline:"none", background:C.bg, color:C.text, width:240 }}/>
        </div>
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
            <thead>
              <tr style={{ background:C.bg, borderBottom:`1px solid ${C.border}` }}>
                {[["id","ID"],["subject","Subject"],["from","From"],["status","Status"],["bucket","Bucket"],["category","Category"],["assigned_to","Agent"],["date","Created"]].map(([field,label])=>(
                  <th key={field} onClick={()=>{ setSortField(field); setSortDir(sortField===field&&sortDir==="asc"?"desc":"asc"); }}
                    style={{ padding:"9px 12px", textAlign:"left", fontWeight:500, color:C.textMuted, cursor:"pointer", whiteSpace:"nowrap", userSelect:"none" }}>
                    {label} {sortField===field?(sortDir==="asc"?"↑":"↓"):""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedTickets.map(t=>(
                <tr key={t.id} onClick={()=>onTicketClick && onTicketClick(t)}
                  style={{ borderBottom:`1px solid ${C.border}`, cursor:onTicketClick?"pointer":"default" }}
                  onMouseEnter={e=>e.currentTarget.style.background=C.bg}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <td style={{ padding:"8px 12px", fontFamily:"monospace", color:C.textLight }}>{t.id}</td>
                  <td style={{ padding:"8px 12px", maxWidth:200, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{t.subject}</td>
                  <td style={{ padding:"8px 12px", color:C.textMuted, maxWidth:150, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{t.from}</td>
                  <td style={{ padding:"8px 12px" }}><span style={{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:99, background:statusBg[t.status]||"#f3f4f6", color:statusColors[t.status]||C.textMuted }}>{t.status}</span></td>
                  <td style={{ padding:"8px 12px", color:C.textMuted }}>{t.bucket}</td>
                  <td style={{ padding:"8px 12px", color:C.textMuted, maxWidth:130, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{t.category}</td>
                  <td style={{ padding:"8px 12px", color:C.textMuted }}>{Array.isArray(t.assignedTo)?t.assignedTo.join(", "):t.assignedTo}</td>
                  <td style={{ padding:"8px 12px", color:C.textMuted, whiteSpace:"nowrap" }}>{formatISTDate(t.date)}</td>
                </tr>
              ))}
              {sortedTickets.length===0&&(<tr><td colSpan={8} style={{ padding:24, textAlign:"center", color:C.textMuted, fontSize:12 }}>No tickets match the selected filters</td></tr>)}
            </tbody>
          </table>
        </div>
        {apiLastPage>1&&(
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:12 }}>
            <span style={{ fontSize:11, color:C.textMuted }}>Page {apiPage} of {apiLastPage} · {totalCount.toLocaleString()} total</span>
            <div style={{ display:"flex", gap:4 }}>
              <button onClick={()=>fetchReportTickets(apiPage-1)} disabled={apiPage===1||loading} style={{ padding:"4px 10px", borderRadius:6, border:`1px solid ${C.border}`, background:"transparent", cursor:apiPage===1?"not-allowed":"pointer", color:C.textMuted, fontSize:11 }}>← Prev</button>
              {Array.from({length:Math.min(5,apiLastPage)},(_,i)=>{ const p=apiPage<=3?i+1:apiPage+i-2; if(p<1||p>apiLastPage) return null; return <button key={p} onClick={()=>fetchReportTickets(p)} style={{ padding:"4px 10px", borderRadius:6, border:`1px solid ${p===apiPage?C.accent:C.border}`, background:p===apiPage?C.accent:"transparent", color:p===apiPage?"#fff":C.textMuted, cursor:"pointer", fontSize:11 }}>{p}</button>; })}
              <button onClick={()=>fetchReportTickets(apiPage+1)} disabled={apiPage===apiLastPage||loading} style={{ padding:"4px 10px", borderRadius:6, border:`1px solid ${C.border}`, background:"transparent", cursor:apiPage===apiLastPage?"not-allowed":"pointer", color:C.textMuted, fontSize:11 }}>Next →</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── CreateTicketModal ─────────────────────────────────────────────────────────
function CreateTicketModal({ onClose, showToast, currentUser }) {
  const [subject, setSubject] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('AP@fairstead.com');
  const [cc, setCc] = useState('');
  const [body, setBody] = useState('');
  const [category, setCategory] = useState('Invoices');
  const [bucket, setBucket] = useState('RP');
  const [assignedTo, setAssignedTo] = useState('');
  const [saving, setSaving] = useState(false);
  const bodyRef = useRef(null);

  const handleSave = async () => {
    if (!subject.trim() || !from.trim()) { showToast('Subject and From are required'); return; }
    setSaving(true);
    try {
      const res = await fetch(`${API}/tickets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subject, from, to, cc, body, category, bucket, status: 'Open', assigned_to: assignedTo, is_vip: 0, reply_count: 0, message_id: 'manual_' + Date.now() })
      });
      if (res.ok) { showToast('Ticket created!'); onClose(true); }
      else { showToast('Error creating ticket'); }
    } catch(e) { showToast('Error: ' + e.message); }
    setSaving(false);
  };

  const inboxes = ['AP@fairstead.com','AP2@fairstead.com','APteam@fairstead.com','enhancorapteam1@enhancor.com','NewVendors@fairstead.com','Legalbilling@fairstead.com','Utilities@fairstead.com'];
  const inputStyle = { width:'100%', border:`1px solid ${COLORS.border}`, borderRadius:6, padding:'8px 10px', fontSize:12, outline:'none', boxSizing:'border-box', color:COLORS.text, background:COLORS.bg, marginBottom:10 };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'#fff', borderRadius:12, padding:24, width:520, maxHeight:'85vh', overflowY:'auto', boxShadow:'0 8px 32px rgba(0,0,0,.2)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <h3 style={{ margin:0, fontSize:15, fontWeight:700, color:COLORS.text }}>Create Ticket Manually</h3>
          <button onClick={() => onClose(false)} style={{ background:'none', border:'none', fontSize:18, cursor:'pointer', color:COLORS.textMuted }}>×</button>
        </div>
        <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>Subject *</div>
        <input value={subject} onChange={e=>setSubject(e.target.value)} placeholder="Email subject" style={inputStyle}/>
        <div style={{ display:'flex', gap:8 }}>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>From *</div>
            <input value={from} onChange={e=>setFrom(e.target.value)} placeholder="sender@email.com" style={inputStyle}/>
          </div>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>CC</div>
            <div style={{ border:`1px solid ${COLORS.border}`, borderRadius:6, padding:'6px 8px', marginBottom:10, position:'relative' }}>
              <CcEmailInput cc={cc} setCc={setCc} />
            </div>
          </div>
        </div>
        <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>Inbox (To)</div>
        <select value={to} onChange={e=>setTo(e.target.value)} style={inputStyle}>
          {inboxes.map(i => <option key={i} value={i}>{i}</option>)}
        </select>
        <div style={{ display:'flex', gap:8 }}>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>Category</div>
            <select value={category} onChange={e=>setCategory(e.target.value)} style={inputStyle}>
              {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>Bucket</div>
            <select value={bucket} onChange={e=>setBucket(e.target.value)} style={inputStyle}>
              <option value="RP">RP</option>
              <option value="YARDI">YARDI</option>
              <option value="Unassigned">Unassigned</option>
            </select>
          </div>
        </div>
        <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>Assign To</div>
        <select value={assignedTo} onChange={e=>setAssignedTo(e.target.value)} style={inputStyle}>
          <option value="">-- Select Agent --</option>
          {AGENTS.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:4 }}>Body / Notes (Ctrl+V to paste screenshot)</div>
        <div
          ref={bodyRef}
          contentEditable={true}
          suppressContentEditableWarning={true}
          onInput={e => setBody(e.currentTarget.innerHTML)}
          onPaste={e => {
            const items = e.clipboardData?.items;
            if (!items) return;
            for (let i = 0; i < items.length; i++) {
              if (items[i].type.startsWith('image/')) {
                e.preventDefault();
                const file = items[i].getAsFile();
                if (!file) return;
                const reader = new FileReader();
                reader.onload = ev => {
                  const img = document.createElement('img');
                  img.src = ev.target.result;
                  img.style.cssText = 'max-width:100%;min-width:400px;height:auto;display:block;margin:4px 0;';
                  if (bodyRef.current) bodyRef.current.appendChild(img);
                  setBody(bodyRef.current?.innerHTML || '');
                };
                reader.readAsDataURL(file);
                return;
              }
            }
          }}
          data-placeholder="Email body or notes... (Ctrl+V to paste screenshot)"
          style={{ width:'100%', border:`1px solid ${COLORS.border}`, borderRadius:6, padding:'8px 10px', fontSize:12, outline:'none', minHeight:100, fontFamily:'system-ui,sans-serif', boxSizing:'border-box', color:COLORS.text, marginBottom:10 }}
        />
        <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:8 }}>
          <button onClick={() => onClose(false)} style={{ padding:'8px 16px', borderRadius:6, border:`1px solid ${COLORS.border}`, background:'#fff', cursor:'pointer', fontSize:12 }}>Cancel</button>
          <button onClick={handleSave} disabled={saving} style={{ padding:'8px 16px', borderRadius:6, border:'none', background:COLORS.accent, color:'#fff', cursor:'pointer', fontSize:12, fontWeight:600 }}>
            {saving ? 'Creating...' : 'Create Ticket'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Main App ──────────────────────────────────────────────────────────────────
export default function App() {
  // One-time side effects — run only on mount
  useEffect(() => {
    document.title = "AP Ticketing System";
    if (!document.getElementById('ce-style')) {
      const s = document.createElement('style');
      s.id = 'ce-style';
      s.textContent = '[contenteditable][data-placeholder]:empty:before{content:attr(data-placeholder);color:#9ca3af;pointer-events:none;display:block;}';
      document.head.appendChild(s);
    }
  }, []);

  const [user, setUser] = useState(() => {
    try { const s=localStorage.getItem("ap_user"); return s?JSON.parse(s):null; } catch(e) { return null; }
  });
  const [loginForm, setLoginForm] = useState({ email:"", password:"" });
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [totalTickets, setTotalTickets] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState("dashboard");
  const [selected, setSelected] = useState(null);
  const [showForward, setShowForward] = useState(false);
  const [showCreateTicket, setShowCreateTicket] = useState(false);
  const [toast, setToast] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [realStats, setRealStats] = useState(null);
  const [agentStats, setAgentStats] = useState({});
  const [appProperties, setAppProperties] = useState([]);
  const [dashPeriod, setDashPeriod] = useState("Today");
  const dashPeriodRef = useRef("Today");

  const detailRef = useRef(null);
  const ticketListRef = useRef(null);
  const searchTimer = useRef(null);
  const filtersRef = useRef(null);

  const showToast = useCallback(msg => { setToast(msg); setTimeout(()=>setToast(""),3000); }, []);

  const isPrivileged = user?.role === "Admin" || user?.role === "Manager" || user?.role === "TL";
  const canViewAll = isPrivileged || VIEW_ALL_AGENTS.includes(user?.name);

  const [filters, setFilters] = useState(() => {
    try {
      const saved = localStorage.getItem("ap_filters");
      const parsed = JSON.parse(saved);
      const privileged = (() => { try { const u=JSON.parse(localStorage.getItem("ap_user")||"{}"); return u.role==="Admin"||u.role==="Manager"||u.role==="TL"; } catch(e){ return true; } })();
      const defaultAgent = (() => { try { const u=JSON.parse(localStorage.getItem("ap_user")||"{}"); return privileged?"All":u.name||"All"; } catch(e){ return "All"; } })();
      return { bucket:"All", status:"Open", search:"", agent:defaultAgent, startDate:"", endDate:"", ...parsed, startDate:"", endDate:"" };
    } catch(e) {
      return { bucket:"All", status:"Open", search:"", agent:"All", startDate:"", endDate:"" };
    }
  });

  // Keep filtersRef in sync
  useEffect(() => { filtersRef.current = filters; }, [filters]);
  // Keep dashPeriodRef in sync
  useEffect(() => { dashPeriodRef.current = dashPeriod; }, [dashPeriod]);

  // Scroll detail panel to top when ticket changes
  useEffect(() => { if(selected && detailRef.current) detailRef.current.scrollTop=0; }, [selected?.id]);

  // fetchStats is stable — reads user via ref to avoid stale closure in interval
  const userRef = useRef(user);
  useEffect(() => { userRef.current = user; }, [user]);

  const fetchStats = useCallback(async (period = 'all') => {
    const u = userRef.current;
    try {
      const privileged = u?.role === "Admin" || u?.role === "Manager" || u?.role === "TL";
      const viewAll = privileged || VIEW_ALL_AGENTS.includes(u?.name);
      const agentParam = (!viewAll && u?.name) ? `&agent=${encodeURIComponent(u.name)}` : '';
      const res = await fetch(`${API}/tickets/stats?period=${period}${agentParam}`);
      const data = await res.json();
      setRealStats(data);
    } catch(e) {}
    try { const res=await fetch(`${API}/agents/stats`); const data=await res.json(); setAgentStats(data); } catch(e) {}
  }, []);

  const fetchTickets = useCallback(async (f, p=1) => {
    const currentFilters = f || filtersRef.current;
    if (!currentFilters) return;
    const u = userRef.current;
    setLoading(true);
    try {
      const params = new URLSearchParams({ per_page:50, page:p });
      if(currentFilters.search) params.append('search', currentFilters.search);
      if(currentFilters.bucket&&currentFilters.bucket!=='All') params.append('bucket', currentFilters.bucket);
      if(currentFilters.status&&currentFilters.status!=='All') params.append('status', currentFilters.status);
      if(currentFilters.agent&&currentFilters.agent!=='All') params.append('agent', currentFilters.agent);
      else if(u && u.role==='Agent' && !VIEW_ALL_AGENTS.includes(u.name)) params.append('agent', u.name);
      if(currentFilters.hasReplies) params.append('has_replies','1');
      if(currentFilters.newOnly) params.append('new_only','1');
      if(currentFilters.startDate) params.append('start_date', currentFilters.startDate);
      if(currentFilters.endDate) params.append('end_date', currentFilters.endDate);
      const res = await fetch(`${API}/tickets?${params}`);
      const data = await res.json();
      const mapped = (data.data||[]).map(t=>({...t, assignedTo:t.assigned_to?t.assigned_to.split(','):['Unassigned'], isVIP:t.is_vip===1||t.is_vip===true, date:t.created_at}))
        .sort((a,b)=>new Date(b.date)-new Date(a.date));
      if(p===1) setTickets(mapped); else setTickets(prev=>[...prev,...mapped]);
      setTotalTickets(data.total||0);
      setCurrentPage(data.current_page||1);
      setLastPage(data.last_page||1);
    } catch(e) { console.error('fetchTickets error:',e); }
    setLoading(false);
  }, []);

  // Bootstrap on login
  useEffect(() => {
    if (!user) return;
    fetchTickets(filtersRef.current, 1);
    fetchStats("today");
    fetch(`${API}/properties`).then(r=>r.json()).then(d=>setAppProperties(Array.isArray(d)?d:[])).catch(()=>{});
    const interval = setInterval(() => {
      fetchTickets(filtersRef.current, 1);
      fetchStats(dashPeriodRef.current.toLowerCase());
    }, 60000);
    return () => clearInterval(interval);
  }, [user, fetchTickets, fetchStats]);

  // Re-fetch when filters change (debounced for search)
  useEffect(() => {
    if (!user) return;
    try { localStorage.setItem("ap_filters", JSON.stringify(filters)); } catch(e) {}
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => { fetchTickets(filters, 1); }, 500);
    return () => clearTimeout(searchTimer.current);
  }, [filters, user, fetchTickets]);

  // Re-fetch stats when dash period changes
  useEffect(() => {
    if (user) fetchStats(dashPeriod.toLowerCase());
  }, [dashPeriod, fetchStats]);

  // Sync agent filter when user changes
  useEffect(() => {
    if (user) {
      const privileged = user.role === "Admin" || user.role === "Manager" || user.role === "TL";
      setFilters(p => ({...p, agent: privileged ? p.agent : user.name}));
    }
  }, [user?.name, user?.role]);

  const handleLogin = async () => {
    if(!loginForm.email||!loginForm.password) return setLoginError("Please enter email and password.");
    setLoginLoading(true); setLoginError("");
    try {
      const res=await fetch(`${API}/login`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:loginForm.email,password:loginForm.password})});
      const data=await res.json();
      if(data.success){ setUser(data.user); try{localStorage.setItem("ap_user",JSON.stringify(data.user));}catch(e){} }
      else setLoginError(data.message||"Invalid email or password.");
    } catch(e){ setLoginError("Connection error. Please try again."); }
    setLoginLoading(false);
  };

  const signOut = () => { setUser(null); try{localStorage.removeItem("ap_user");}catch(e){} };

  const updateTicket = useCallback(async (id, changes) => {
    setTickets(p => p.map(t => t.id === id ? {...t, ...changes} : t));
    setSelected(p => p?.id === id ? {...p, ...changes} : p);
    try {
      await fetch(`${API}/tickets/${id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify(changes) });
      setTimeout(() => fetchTickets(filtersRef.current, 1), 500);
    } catch(e) { console.error('Update error:', e); }
  }, [fetchTickets]);

  const selectTicket = (t) => { setSelected(t); if(detailRef.current) detailRef.current.scrollTop=0; };

  const goTickets = (f) => {
    if (user && !canViewAll) f = { ...f, agent: user.name };
    setFilters(f); setSelected(null); setPage("tickets");
  };

  const dashTickets = useMemo(() => {
    let filtered = canViewAll ? tickets : tickets.filter(t => {
      const a = Array.isArray(t.assignedTo) ? t.assignedTo.join(",") : t.assignedTo;
      return a?.includes(user?.name);
    });
    const now = new Date();
    if (dashPeriod === "Today") filtered = filtered.filter(t => new Date(t.date).toDateString() === now.toDateString());
    else if (dashPeriod === "Week") { const wa=new Date(now-7*24*60*60*1000); filtered=filtered.filter(t=>new Date(t.date)>=wa); }
    else if (dashPeriod === "Month") { const ma=new Date(now-30*24*60*60*1000); filtered=filtered.filter(t=>new Date(t.date)>=ma); }
    return filtered;
  }, [tickets, canViewAll, user?.name, dashPeriod]);

  const stats = {
    total:      realStats?.total      ?? 0,
    open:       realStats?.open       ?? 0,
    inProgress: realStats?.in_progress ?? 0,
    vip:        realStats?.vip        ?? 0,
    rp:         realStats?.rp         ?? 0,
    yardi:      realStats?.yardi      ?? 0,
    resolved:   realStats?.resolved   ?? 0,
    noAction:   realStats?.no_action  ?? 0,
  };
  const chartTotal = stats.total || 1;

  // ── Login screen ────────────────────────────────────────────────────────────
  if (!user) return (
    <div style={{ minHeight:"100vh", background:"#f0f4ff", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"system-ui,sans-serif", position:"relative", overflow:"hidden" }}>
      <div style={{ position:"absolute", top:"-100px", left:"-100px", width:400, height:400, borderRadius:"50%", background:"#4f6ef710", pointerEvents:"none" }}/>
      <div style={{ position:"absolute", bottom:"-80px", right:"-80px", width:350, height:350, borderRadius:"50%", background:"#7c3aed10", pointerEvents:"none" }}/>
      <div style={{ width:"100%", maxWidth:440, padding:24, position:"relative", zIndex:1 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ width:64, height:64, background:COLORS.accent, borderRadius:18, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:24, fontWeight:700, margin:"0 auto 16px" }}>AP</div>
          <div style={{ fontSize:24, fontWeight:700, color:COLORS.text }}>AP Ticketing System</div>
          <div style={{ fontSize:13, color:COLORS.textMuted, marginTop:6 }}>Fairstead · Enhancor · Accounts Payable</div>
        </div>
        <div style={{ background:"#fff", border:`1px solid ${COLORS.border}`, borderRadius:16, padding:32 }}>
          <div style={{ fontSize:15, fontWeight:600, color:COLORS.text, marginBottom:6 }}>Welcome back!</div>
          <div style={{ fontSize:13, color:COLORS.textMuted, marginBottom:22 }}>Sign in to your account to continue</div>
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:12, color:COLORS.textMuted, marginBottom:5, fontWeight:500 }}>Email address</div>
            <input type="email" placeholder="you@enhancor.com" value={loginForm.email} onChange={e=>setLoginForm(p=>({...p,email:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&handleLogin()} style={{ width:"100%", border:`1.5px solid ${COLORS.border}`, borderRadius:9, padding:"11px 14px", fontSize:13, outline:"none", boxSizing:"border-box", color:COLORS.text, background:"#fafafa" }}/>
          </div>
          <div style={{ marginBottom:18 }}>
            <div style={{ fontSize:12, color:COLORS.textMuted, marginBottom:5, fontWeight:500 }}>Password</div>
            <input type="password" placeholder="••••••••" value={loginForm.password} onChange={e=>setLoginForm(p=>({...p,password:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&handleLogin()} style={{ width:"100%", border:`1.5px solid ${COLORS.border}`, borderRadius:9, padding:"11px 14px", fontSize:13, outline:"none", boxSizing:"border-box", color:COLORS.text, background:"#fafafa" }}/>
          </div>
          {loginError&&<div style={{ fontSize:12, color:COLORS.vip, background:COLORS.vipLight, border:`1px solid #fecaca`, padding:"9px 12px", borderRadius:8, marginBottom:14 }}>{loginError}</div>}
          <button onClick={handleLogin} disabled={loginLoading} style={{ width:"100%", background:loginLoading?COLORS.textLight:COLORS.accent, color:"#fff", border:"none", borderRadius:9, padding:"12px", fontSize:14, fontWeight:600, cursor:loginLoading?"not-allowed":"pointer" }}>
            {loginLoading?"Signing in...":"Sign in →"}
          </button>
        </div>
        <div style={{ textAlign:"center", marginTop:16, fontSize:11, color:COLORS.textLight }}>AP Ticketing System v1.0 · Enhancor</div>
      </div>
    </div>
  );

  const navItems = [
    { id:"dashboard", icon:"▤", label:"Dashboard" },
    { id:"tickets",   icon:"◈", label:"All Tickets" },
    { id:"inboxes",   icon:"✉", label:"Inboxes" },
    { id:"agents",    icon:"◉", label:"Agents" },
    { id:"reports",   icon:"◫", label:"Reports" },
    ...(user.role==="Admin"?[{ id:"users", icon:"👤", label:"Users" },{ id:"properties", icon:"🏢", label:"Properties" }]:[]),
  ];

  return (
    <>
    <style>{`
  .email-body img { max-width:100% !important; height:auto !important; display:block; margin:4px 0; }
  .email-body table { width:100% !important; border-collapse:collapse; }
  .email-body td, .email-body th { padding:4px 8px; border:1px solid #e5e7eb; font-size:12px; }
  .email-body [style*="background-color:#00263e"],
  .email-body [style*="background-color: #00263e"],
  .email-body [style*="background:#00263e"],
  .email-body td[bgcolor="#00263e"],
  .email-body table[bgcolor="#00263e"] { background-color:#f8f9fc !important; color:#111827 !important; }
  .email-body [style*="color:rgb(255,255,255)"] { color:#111827 !important; }
  .email-body [style*="color: rgb(255,255,255)"] { color:#111827 !important; }
`}</style>
    <div style={{ display:"flex", minHeight:"100vh", fontFamily:"system-ui,sans-serif", fontSize:13, background:COLORS.bg }}>
      {toast&&<div style={{ position:"fixed", top:16, right:16, zIndex:9999, background:"#1e1f2e", color:"#fff", padding:"10px 16px", borderRadius:8, fontSize:12 }}>{toast}</div>}
      {showCreateTicket && <CreateTicketModal onClose={(created) => { setShowCreateTicket(false); if(created) fetchTickets(filtersRef.current,1); }} showToast={showToast} currentUser={user}/>}
      {showForward && selected && <ForwardModal ticket={selected} onClose={()=>setShowForward(false)} showToast={showToast}/>}

      {/* Sidebar */}
      {sidebarOpen&&(
        <div style={{ width:200, background:COLORS.sidebar, display:"flex", flexDirection:"column", padding:"16px 10px", position:"fixed", top:0, left:0, bottom:0, zIndex:100 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, padding:"0 4px 20px" }}>
            <div style={{ width:28, height:28, background:COLORS.accent, borderRadius:7, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:12, fontWeight:700 }}>AP</div>
            <div>
              <div style={{ color:"#fff", fontWeight:600, fontSize:13, lineHeight:1.2 }}>AP Tickets</div>
              <div style={{ color:COLORS.sidebarText, fontSize:10 }}>Fairstead · Enhancor</div>
            </div>
          </div>
          <div style={{ flex:1, display:"flex", flexDirection:"column", gap:2 }}>
            {navItems.map(n=>{
              const active=page===n.id;
              return (
                <button key={n.id} onClick={()=>{setPage(n.id);setSelected(null);}}
                  style={{ display:"flex", alignItems:"center", gap:10, padding:"9px 14px", borderRadius:8, cursor:"pointer", color:active?"#fff":COLORS.sidebarText, background:active?COLORS.sidebarActive:"transparent", fontSize:13, fontWeight:active?500:400, border:"none", textAlign:"left", width:"100%" }}>
                  <span style={{ fontSize:14, width:16 }}>{n.icon}</span>{n.label}
                </button>
              );
            })}
          </div>
          <div style={{ borderTop:"1px solid #2d2f45", paddingTop:12 }}>
            <div style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 14px" }}>
              <Avatar name={user.name} size={26} color={COLORS.accent}/>
              <div>
                <div style={{ color:"#fff", fontSize:11, fontWeight:500 }}>{user.name}</div>
                <div style={{ color:COLORS.sidebarText, fontSize:10 }}>{user.role}</div>
              </div>
            </div>
            <button onClick={signOut} style={{ display:"flex", alignItems:"center", gap:8, padding:"6px 14px", borderRadius:8, cursor:"pointer", color:COLORS.sidebarText, fontSize:11, background:"none", border:"none", width:"100%" }}>
              <span style={{ fontSize:12 }}>⏻</span> Sign out
            </button>
          </div>
        </div>
      )}

      {/* Main content */}
      <div style={{ flex:1, marginLeft:sidebarOpen?200:0 }}>
        {/* Top bar */}
        <div style={{ background:COLORS.cardBg, borderBottom:`1px solid ${COLORS.border}`, padding:"10px 20px", display:"flex", alignItems:"center", gap:12, position:"sticky", top:0, zIndex:99 }}>
          <button onClick={()=>setSidebarOpen(p=>!p)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:16, color:COLORS.textMuted, padding:4 }}>☰</button>
          <div style={{ flex:1, fontSize:14, fontWeight:500, color:COLORS.text }}>
            {{dashboard:"Dashboard",tickets:"All Tickets",inboxes:"Inboxes",agents:"Agents",reports:"Reports",users:"Users",properties:"Properties"}[page]}
            {loading&&<span style={{ fontSize:11, color:COLORS.textMuted, marginLeft:8 }}>Loading...</span>}
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:6, fontSize:11, background:COLORS.successLight, color:COLORS.success, padding:"4px 10px", borderRadius:99 }}>
            <div style={{ width:6, height:6, borderRadius:"50%", background:COLORS.success }}/>Outlook connected
          </div>
        </div>

        <div style={{ padding:20 }}>
          {/* ── Dashboard ── */}
          {page==="dashboard"&&<>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
              <div>
                <div style={{ fontSize:18, fontWeight:600, color:COLORS.text }}>Welcome back, {user.name} 👋</div>
                <div style={{ fontSize:12, color:COLORS.textMuted, marginTop:2 }}>Here's what's happening with your tickets</div>
              </div>
              <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                {["Today","Week","Month","All"].map(p=>(
                  <button key={p} onClick={()=>setDashPeriod(p)}
                    style={{ padding:"5px 12px", borderRadius:99, fontSize:11, cursor:"pointer", fontWeight:500, background:dashPeriod===p?COLORS.accent:COLORS.bg, color:dashPeriod===p?"#fff":COLORS.textMuted, border:`1px solid ${dashPeriod===p?COLORS.accent:COLORS.border}` }}>
                    {p}
                  </button>
                ))}
                <div style={{ fontSize:11, color:COLORS.textMuted, background:COLORS.bg, border:`1px solid ${COLORS.border}`, padding:"6px 12px", borderRadius:8 }}>
                  {new Date().toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'})}
                </div>
              </div>
            </div>

            {/* Stat cards */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(8,1fr)", gap:10, marginBottom:20 }}>
              {[
                ["Total",     stats.total,      COLORS.text,    "◈", {bucket:"All",status:"All",search:"",agent:isPrivileged?"All":user?.name}],
                ["Open",      stats.open,       COLORS.accent,  "○", {bucket:"All",status:"Open",search:"",agent:isPrivileged?"All":user?.name}],
                ["In Progress",stats.inProgress,COLORS.warning, "◑", {bucket:"All",status:"In Progress",search:"",agent:isPrivileged?"All":user?.name}],
                ["VIP",       stats.vip,        COLORS.vip,     "⚡",{bucket:"All",status:"All",search:"",agent:isPrivileged?"All":user?.name}],
                ["RP",        stats.rp,         COLORS.rp,      "◆", {bucket:"RP",status:"All",search:"",agent:"All"}],
                ["YARDI",     stats.yardi,      COLORS.yardi,   "◇", {bucket:"YARDI",status:"All",search:"",agent:"All"}],
                ["Resolved",  stats.resolved,   COLORS.success, "✓", {bucket:"All",status:"Resolved",search:"",agent:isPrivileged?"All":user?.name}],
                ["No Action", stats.noAction,   "#64748b",      "—", {bucket:"All",status:"No Action Required",search:"",agent:isPrivileged?"All":user?.name}],
              ].map(([l,v,c,icon,f])=>(
                <button key={l} onClick={()=>goTickets(f)} style={{ padding:"14px 12px", cursor:"pointer", background:COLORS.cardBg, border:`1px solid ${COLORS.border}`, borderTop:`3px solid ${c}`, borderRadius:12, textAlign:"left", width:"100%" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                    <div style={{ fontSize:22, fontWeight:700, color:c }}>{v?.toLocaleString()}</div>
                    <span style={{ fontSize:14, color:c+"88" }}>{icon}</span>
                  </div>
                  <div style={{ fontSize:10, color:COLORS.textMuted, marginTop:4, fontWeight:500 }}>{l}</div>
                </button>
              ))}
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
              {/* By category */}
              <Card style={{ padding:20 }}>
                <div style={{ fontWeight:500, marginBottom:16, color:COLORS.text, fontSize:13 }}>Tickets by category</div>
                {CATEGORIES.map((cat,i)=>{
                  const n = realStats?.by_category?.[cat] ?? 0;
                  const pct = Math.round((n / chartTotal) * 100) || 0;
                  const colors=["#4f6ef7","#7c3aed","#0ea5e9","#16a34a","#d97706","#e84949"];
                  return (
                    <button key={cat} onClick={()=>goTickets({bucket:"All",status:"All",search:cat,agent:"All"})}
                      style={{ display:"block", width:"100%", background:"none", border:"none", textAlign:"left", cursor:"pointer", marginBottom:10, padding:"4px 6px", borderRadius:6 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, marginBottom:4 }}>
                        <span style={{ color:COLORS.textMuted }}>{cat}</span>
                        <span style={{ fontWeight:600, color:COLORS.text }}>{n}</span>
                      </div>
                      <div style={{ height:8, background:COLORS.border, borderRadius:99, overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${pct}%`, background:colors[i%colors.length], borderRadius:99 }}/>
                      </div>
                    </button>
                  );
                })}
              </Card>

              {/* Bucket split donut */}
              <Card style={{ padding:20 }}>
                <div style={{ fontWeight:500, marginBottom:16, color:COLORS.text, fontSize:13 }}>Bucket split</div>
                <div style={{ display:"flex", alignItems:"center", gap:24 }}>
                  <svg width="120" height="120" viewBox="0 0 120 120">
                    {(()=>{
                      const data=[["RP",stats.rp,COLORS.rp],["YARDI",stats.yardi,COLORS.yardi],["Unassigned",Math.max((stats.total||0)-(stats.rp||0)-(stats.yardi||0),0),"#9ca3af"]];
                      const total=data.reduce((s,[,v])=>s+(v||0),0)||1;
                      let angle=-90;
                      return data.map(([l,v,c])=>{
                        const pct=(v||0)/total; const sa=angle; angle+=pct*360;
                        const r=50,cx=60,cy=60,ir=32,toRad=a=>a*Math.PI/180;
                        const x1=cx+r*Math.cos(toRad(sa)),y1=cy+r*Math.sin(toRad(sa));
                        const x2=cx+r*Math.cos(toRad(angle-0.5)),y2=cy+r*Math.sin(toRad(angle-0.5));
                        const ix1=cx+ir*Math.cos(toRad(sa)),iy1=cy+ir*Math.sin(toRad(sa));
                        const ix2=cx+ir*Math.cos(toRad(angle-0.5)),iy2=cy+ir*Math.sin(toRad(angle-0.5));
                        const large=pct>0.5?1:0;
                        return <path key={l} d={`M${ix1},${iy1} L${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2} L${ix2},${iy2} A${ir},${ir} 0 ${large},0 ${ix1},${iy1}`} fill={c} stroke="#fff" strokeWidth="2" style={{cursor:"pointer"}} onClick={()=>goTickets({bucket:l,status:"All",search:"",agent:"All"})}/>;
                      });
                    })()}
                    <text x="60" y="56" textAnchor="middle" fontSize="11" fontWeight="700" fill={COLORS.text}>{(stats.total||0).toLocaleString()}</text>
                    <text x="60" y="70" textAnchor="middle" fontSize="9" fill={COLORS.textMuted}>total</text>
                  </svg>
                  <div style={{ flex:1 }}>
                    {[["RP",stats.rp,COLORS.rp],["YARDI",stats.yardi,COLORS.yardi],["Unassigned",Math.max((stats.total||0)-(stats.rp||0)-(stats.yardi||0),0),"#9ca3af"]].map(([l,v,c])=>(
                      <button key={l} onClick={()=>goTickets({bucket:l,status:"All",search:"",agent:"All"})} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10, width:"100%", background:"none", border:"none", cursor:"pointer", textAlign:"left", padding:"2px 4px", borderRadius:6 }}>
                        <div style={{ width:10, height:10, borderRadius:2, background:c, flexShrink:0 }}/>
                        <span style={{ flex:1, fontSize:12, color:COLORS.textMuted }}>{l}</span>
                        <span style={{ fontWeight:600, color:c, fontSize:13 }}>{(v||0).toLocaleString()}</span>
                        <span style={{ fontSize:11, color:COLORS.textLight }}>{Math.round((v||0)/Math.max(stats.total,1)*100)}%</span>
                      </button>
                    ))}
                  </div>
                </div>
              </Card>
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16, marginBottom:16 }}>
              {/* Status overview */}
              <Card style={{ padding:20 }}>
                <div style={{ fontWeight:500, marginBottom:16, color:COLORS.text, fontSize:13 }}>Status overview</div>
                {STATUSES.map(s=>{
                  const n = realStats?.by_status?.[s] ?? 0;
                  const pct = Math.round(n / chartTotal * 100) || 0;
                  const map={Open:COLORS.accent,"In Progress":COLORS.warning,"On Hold":"#9333ea",Escalated:COLORS.vip,Resolved:COLORS.success,Closed:COLORS.textMuted};
                  return (
                    <button key={s} onClick={()=>goTickets({bucket:"All",status:s,search:"",agent:"All"})} style={{ display:"block", width:"100%", background:"none", border:"none", textAlign:"left", cursor:"pointer", marginBottom:10, padding:"4px 6px", borderRadius:6 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, marginBottom:3 }}>
                        <span style={{ color:COLORS.textMuted }}>{s}</span>
                        <span style={{ fontWeight:600, color:map[s]||COLORS.textMuted }}>{n} <span style={{ color:COLORS.textLight, fontWeight:400 }}>({pct}%)</span></span>
                      </div>
                      <div style={{ height:6, background:COLORS.border, borderRadius:99, overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${pct}%`, background:map[s]||COLORS.textMuted, borderRadius:99 }}/>
                      </div>
                    </button>
                  );
                })}
              </Card>

              {/* Agent workload */}
              <Card style={{ padding:20 }}>
                <div style={{ fontWeight:500, marginBottom:16, color:COLORS.text, fontSize:13 }}>Agent workload</div>
                {AGENTS.slice(0,8).map((a,i)=>{
                  const n = realStats?.by_agent?.[a] ?? agentStats[a]?.total ?? 0;
                  const colors=[COLORS.accent,"#7c3aed","#0ea5e9","#16a34a","#d97706","#e84949","#9333ea","#0891b2"];
                  return (
                    <button key={a} onClick={()=>goTickets({bucket:"All",status:"All",search:"",agent:a})} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:9, width:"100%", background:"none", border:"none", cursor:"pointer", textAlign:"left", padding:"2px 4px", borderRadius:6 }}>
                      <Avatar name={a} size={22} color={colors[i%colors.length]}/>
                      <span style={{ flex:1, color:COLORS.textMuted, fontSize:11 }}>{a}</span>
                      <div style={{ width:60, height:5, background:COLORS.border, borderRadius:99, overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${Math.min(Math.round(n/chartTotal*100)*3,100)}%`, background:colors[i%colors.length], borderRadius:99 }}/>
                      </div>
                      <span style={{ fontWeight:600, color:COLORS.text, fontSize:11, minWidth:14 }}>{n}</span>
                    </button>
                  );
                })}
              </Card>

              {/* Recent tickets */}
              <Card style={{ padding:20 }}>
                <div style={{ fontWeight:500, marginBottom:14, color:COLORS.text, fontSize:13, display:"flex", justifyContent:"space-between" }}>
                  Recent tickets
                  <button onClick={()=>goTickets({bucket:"All",status:"All",search:"",agent:isPrivileged?"All":user?.name})} style={{ fontSize:11, color:COLORS.accent, background:"none", border:"none", cursor:"pointer" }}>View all →</button>
                </div>
                {dashTickets.slice(0,5).map(t=>(
                  <button key={t.id} onClick={()=>{setSelected(t);setPage("tickets");}} style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 0", cursor:"pointer", width:"100%", background:"none", border:"none", borderBottom:`1px solid ${COLORS.border}`, textAlign:"left" }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:11, fontWeight:500, color:COLORS.text, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{t.subject}</div>
                      <div style={{ fontSize:10, color:COLORS.textMuted }}>{t.from}</div>
                    </div>
                    <div style={{ display:"flex", gap:3, flexShrink:0 }}>
                      {t.isVIP&&<Badge label="VIP" color={COLORS.vip} bg={COLORS.vipLight}/>}
                      {statusBadge(t.status)}
                    </div>
                  </button>
                ))}
                {dashTickets.length===0&&<div style={{ fontSize:11, color:COLORS.textMuted, textAlign:"center", paddingTop:12 }}>No tickets for this period</div>}
              </Card>
            </div>

            {/* Inbox activity */}
            <Card style={{ padding:20 }}>
              <div style={{ fontWeight:500, marginBottom:16, color:COLORS.text, fontSize:13 }}>Inbox activity</div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:12 }}>
                {INBOXES.slice(0,5).map((inbox,i)=>{
                  const n=dashTickets.filter(t=>t.to===inbox).length;
                  const vips=dashTickets.filter(t=>t.to===inbox&&t.isVIP).length;
                  const colors=[COLORS.accent,"#7c3aed","#0ea5e9","#16a34a","#d97706"];
                  const pct=Math.round(n/Math.max(dashTickets.length,1)*100)||0;
                  return (
                    <button key={inbox} onClick={()=>goTickets({bucket:"All",status:"All",search:inbox,agent:"All"})} style={{ background:COLORS.bg, borderRadius:10, padding:"14px 16px", border:`1px solid ${COLORS.border}`, textAlign:"left", cursor:"pointer", width:"100%" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                        <div style={{ fontSize:10, color:COLORS.textMuted, fontWeight:500, lineHeight:1.4 }}>{inbox}</div>
                        <div style={{ width:8, height:8, borderRadius:"50%", background:COLORS.success }}/>
                      </div>
                      <div style={{ fontSize:24, fontWeight:700, color:colors[i], marginBottom:4 }}>{n}</div>
                      <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:8 }}>tickets · {vips} VIP</div>
                      <div style={{ height:4, background:COLORS.border, borderRadius:99, overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${pct}%`, background:colors[i], borderRadius:99 }}/>
                      </div>
                    </button>
                  );
                })}
              </div>
            </Card>
          </>}

          {/* ── Tickets ── */}
          {page==="tickets"&&(
            <div style={{ display:"flex", gap:16 }}>
              {/* Ticket list */}
              <div ref={ticketListRef} style={{ width:340, flexShrink:0, overflowY:"auto", maxHeight:"calc(100vh - 120px)", position:"sticky", top:0 }}>
                <Card style={{ padding:12, marginBottom:10 }}>
                  <div style={{ display:"flex", gap:4, marginBottom:8, flexWrap:"wrap" }}>
                    {["All","Open","In Progress","On Hold","Escalated","Closed","No Action Required"].map(s=>(
                      <button key={s} onClick={()=>setFilters(p=>({...p,status:s==="All"?"All":s}))}
                        style={{ padding:"4px 10px", borderRadius:99, fontSize:11, cursor:"pointer", fontWeight:500, background:filters.status===(s==="All"?"All":s)?COLORS.accent:COLORS.bg, color:filters.status===(s==="All"?"All":s)?"#fff":COLORS.textMuted, border:`1px solid ${filters.status===(s==="All"?"All":s)?COLORS.accent:COLORS.border}` }}>
                        {s}
                      </button>
                    ))}
                    <button onClick={()=>setFilters(p=>({...p,hasReplies:!p.hasReplies}))}
                      style={{ padding:"4px 10px", borderRadius:99, fontSize:11, cursor:"pointer", fontWeight:500, background:filters.hasReplies?COLORS.success:COLORS.bg, color:filters.hasReplies?"#fff":COLORS.textMuted, border:`1px solid ${filters.hasReplies?COLORS.success:COLORS.border}` }}>
                      💬 Has Replies
                    </button>
                    <button onClick={()=>setFilters(p=>({...p,newOnly:!p.newOnly}))}
                      style={{ padding:"4px 10px", borderRadius:99, fontSize:11, cursor:"pointer", fontWeight:500, background:filters.newOnly?COLORS.accent:COLORS.bg, color:filters.newOnly?"#fff":COLORS.textMuted, border:`1px solid ${filters.newOnly?COLORS.accent:COLORS.border}` }}>
                      🆕 New
                    </button>
                  </div>
                  {isPrivileged && (
                    <select value={filters.agent||"All"} onChange={e=>setFilters(p=>({...p,agent:e.target.value}))}
                      style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"7px 10px", fontSize:12, background:COLORS.bg, color:COLORS.text, outline:"none", marginBottom:8 }}>
                      <option value="All">All Agents</option>
                      {AGENTS.map(a=><option key={a} value={a}>{a}</option>)}
                    </select>
                  )}
                  <input value={filters.search} onChange={e=>setFilters(p=>({...p,search:e.target.value}))} placeholder="Search tickets..."
                    style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"7px 10px", fontSize:12, outline:"none", boxSizing:"border-box", background:COLORS.bg, color:COLORS.text }}/>
                  <button onClick={()=>setShowCreateTicket(true)} style={{ marginTop:6, width:"100%", padding:"7px 14px", borderRadius:6, border:"none", background:COLORS.accent, color:"#fff", cursor:"pointer", fontSize:12, fontWeight:600 }}>+ New Ticket</button>
                  <div style={{ display:"flex", gap:8, marginTop:8 }}>
                    <select value={filters.bucket} onChange={e=>setFilters(p=>({...p,bucket:e.target.value}))}
                      style={{ flex:1, border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"6px 8px", fontSize:11, background:COLORS.bg, color:COLORS.text, outline:"none" }}>
                      {["All","RP","YARDI","Unassigned"].map(o=><option key={o}>{o}</option>)}
                    </select>
                  </div>
                  <div style={{ display:"flex", gap:8, marginTop:8 }}>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:3 }}>From</div>
                      <input type="date" value={filters.startDate||""} onChange={e=>setFilters(p=>({...p,startDate:e.target.value}))}
                        style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"5px 6px", fontSize:11, background:COLORS.bg, color:COLORS.text, outline:"none", boxSizing:"border-box" }}/>
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:3 }}>To</div>
                      <input type="date" value={filters.endDate||""} onChange={e=>setFilters(p=>({...p,endDate:e.target.value}))} min={filters.startDate||""}
                        style={{ width:"100%", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"5px 6px", fontSize:11, background:COLORS.bg, color:COLORS.text, outline:"none", boxSizing:"border-box" }}/>
                    </div>
                    {(filters.startDate||filters.endDate) && (
                      <button onClick={()=>setFilters(p=>({...p,startDate:"",endDate:""}))}
                        style={{ padding:"5px 8px", borderRadius:8, border:`1px solid ${COLORS.border}`, background:"transparent", color:COLORS.vip, fontSize:10, cursor:"pointer", alignSelf:"flex-end", marginBottom:1 }}>✕</button>
                    )}
                  </div>
                  <div style={{ fontSize:11, color:COLORS.textMuted, marginTop:8 }}>
                    {loading?"Loading...":`${tickets.length.toLocaleString()} of ${totalTickets.toLocaleString()} tickets`}
                  </div>
                </Card>

                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                  {tickets.map(t=>(
                    <button key={t.id} onClick={()=>selectTicket(t)}
                      style={{ padding:12, cursor:"pointer", background:selected?.id===t.id?COLORS.accentLight:t.reply_count>0?"#f0fff4":COLORS.cardBg, border:`1.5px solid ${selected?.id===t.id?COLORS.accent:t.reply_count>0?COLORS.success:COLORS.border}`, borderRadius:12, textAlign:"left", width:"100%", position:"relative" }}>
                      {new Date(t.date) > new Date(Date.now() - 2*60*60*1000) && (
                        <div style={{ position:"absolute", top:8, right:8, width:8, height:8, borderRadius:"50%", background:COLORS.accent, boxShadow:`0 0 6px ${COLORS.accent}` }}/>
                      )}
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                        <span style={{ fontSize:10, fontFamily:"monospace", color:COLORS.textLight }}>{t.id}</span>
                        <div style={{ display:"flex", gap:4 }}>
                          {new Date(t.date) > new Date(Date.now() - 2*60*60*1000) && <Badge label="🆕 New" color="#fff" bg={COLORS.accent}/>}
                          {t.reply_count>0&&<Badge label={`💬 ${t.reply_count}`} color={COLORS.success} bg={COLORS.successLight}/>}
                          {t.isVIP&&<Badge label="VIP" color={COLORS.vip} bg={COLORS.vipLight}/>}
                          {bucketBadge(t.bucket)}
                        </div>
                      </div>
                      <div style={{ fontWeight:500, color:COLORS.text, fontSize:12, marginBottom:3, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{t.subject}</div>
                      <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:6, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{t.from}</div>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        {statusBadge(t.status)}
                        <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end" }}>
                          <span style={{ fontSize:10, color:COLORS.textLight }}>{Array.isArray(t.assignedTo)?t.assignedTo.join(", "):t.assignedTo}</span>
                          {t.last_reply_at&&<span style={{ fontSize:9, color:COLORS.success }}>↩ {formatISTDate(t.last_reply_at)}</span>}
                        </div>
                      </div>
                    </button>
                  ))}
                  {currentPage<lastPage&&(
                    <button onClick={()=>fetchTickets(filters,currentPage+1)} style={{ padding:"10px", background:COLORS.accentLight, border:`1px solid ${COLORS.accent}`, borderRadius:8, color:COLORS.accent, fontSize:12, cursor:"pointer", fontWeight:500 }}>
                      Load more ({(totalTickets-tickets.length).toLocaleString()} remaining)
                    </button>
                  )}
                  {!tickets.length&&!loading&&<div style={{ textAlign:"center", color:COLORS.textMuted, padding:40, fontSize:12 }}>No tickets found</div>}
                </div>
              </div>

              {/* Ticket detail */}
              <div ref={detailRef} style={{ flex:1, background:COLORS.cardBg, border:`1px solid ${COLORS.border}`, borderRadius:12, minHeight:400, overflowY:"auto", maxHeight:"calc(100vh - 120px)" }}>
                {!selected ? (
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100%", minHeight:400, color:COLORS.textMuted }}>
                    <div style={{ textAlign:"center" }}>
                      <div style={{ fontSize:36, marginBottom:8 }}>◈</div>
                      <div style={{ fontSize:13, marginBottom:4 }}>Click any ticket to view details</div>
                      <div style={{ fontSize:11, color:COLORS.textLight }}>Detail will appear here</div>
                    </div>
                  </div>
                ) : (
                  <div>
                    {/* Sticky header */}
                    <div style={{ position:"sticky", top:0, background:COLORS.cardBg, borderBottom:`1px solid ${COLORS.border}`, padding:"12px 20px", zIndex:10, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                      <button onClick={()=>setSelected(null)} style={{ background:"none", border:`1px solid ${COLORS.border}`, borderRadius:8, padding:"6px 12px", fontSize:12, cursor:"pointer", color:COLORS.textMuted }}>← Back</button>
                      <span style={{ fontSize:11, color:COLORS.textMuted, fontFamily:"monospace" }}>{selected.id}</span>
                      {selected.isVIP&&<Badge label="⚡ VIP" color={COLORS.vip} bg={COLORS.vipLight}/>}
                      {bucketBadge(selected.bucket)}
                      {statusBadge(selected.status)}
                      <div style={{ marginLeft:"auto", display:"flex", gap:8, alignItems:"center" }}>
                        <button onClick={()=>setShowForward(true)} style={{ padding:"7px 14px", borderRadius:8, border:`1px solid ${COLORS.border}`, background:COLORS.cardBg, color:COLORS.text, fontSize:12, cursor:"pointer", fontWeight:500 }}>↪ Forward</button>
                        <ActivityLogInline ticketId={selected.id} />
                        <DropdownReply ticket={selected} showToast={showToast} onReplySent={note=>updateTicket(selected.id,{body:selected.body+note})}/>
                        <DropdownActions ticket={selected} updateTicket={updateTicket} showToast={showToast} properties={appProperties} isPrivileged={isPrivileged}/>
                      </div>
                    </div>

                    <div style={{ padding:20 }}>
                      <h3 style={{ margin:"0 0 16px", fontSize:18, fontWeight:600, color:COLORS.text }}>{selected.subject}</h3>
                      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:16 }}>
                        {[
                          ["From", selected.from||""],
                          ["To", (selected.to_recipients||selected.to)||""],
                          ["Assigned", Array.isArray(selected.assignedTo)?selected.assignedTo.join(", "):selected.assignedTo],
                          ["Category", selected.category],
                          ["Bucket", selected.bucket],
                          ["Created", formatIST(selected.date)],
                        ].map(([l,v])=>(
                          <div key={l} style={{ background:COLORS.bg, borderRadius:8, padding:"10px 12px" }}>
                            <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:2 }}>{l}</div>
                            <div style={{ fontSize:12, fontWeight:500, color:COLORS.text, wordBreak:"break-all" }}>{v || "—"}</div>
                          </div>
                        ))}
                        {selected.cc&&(
                          <div style={{ background:COLORS.bg, borderRadius:8, padding:"10px 12px" }}>
                            <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:2 }}>CC</div>
                            <div style={{ fontSize:12, fontWeight:500, color:COLORS.text, wordBreak:"break-all" }}>{selected.cc}</div>
                          </div>
                        )}
                      </div>

                      <AttachmentsSection ticketId={selected.id}/>
                      <NotesSection ticketId={selected.id} currentUser={user}/>

                      {/* Email thread */}
                      <div style={{ marginBottom:16 }}>
                        <div style={{ fontSize:11, color:COLORS.textMuted, marginBottom:8, fontWeight:500 }}>Email Thread</div>
                        {(selected.body||'').split('--- Reply from ').map((part,i)=>({part,i})).reverse().map(({part,i})=>(
                          <div key={i} style={{ marginBottom:10, padding:14, background:i===0?COLORS.bg:"#f0f4ff", borderRadius:8, border:`1px solid ${i===0?COLORS.border:COLORS.accent+"44"}` }}>
                           {i>0&&(
  <div style={{ fontSize:11, fontWeight:600, color:COLORS.accent, marginBottom:8, paddingBottom:6, borderBottom:`1px solid ${COLORS.border}` }}>
    💬 Reply from {part.split(' ---')[0]}
  </div>
)}
{i===0&&(
  <div style={{ fontSize:10, color:COLORS.textMuted, marginBottom:8, paddingBottom:6, borderBottom:`1px solid ${COLORS.border}` }}>
    📧 Received · {formatIST(selected.created_at || selected.date)}
  </div>
)}  
<EmailBodyFrame html={(()=>{
  let html = i>0 ? part.substring(part.indexOf('---\n')+4) : part;
  html = html.replace(/src="cid:[^"]*"/gi, 'src=""');
  return html;
})()} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ── Inboxes ── */}
          {page==="inboxes"&&(
            <div style={{ maxWidth:700 }}>
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {INBOXES.map(inbox=>{
                  const n=dashTickets.filter(t=>t.to===inbox).length;
                  return (
                    <Card key={inbox} style={{ padding:16, display:"flex", alignItems:"center", gap:14 }}>
                      <div style={{ width:36, height:36, borderRadius:9, background:COLORS.accentLight, display:"flex", alignItems:"center", justifyContent:"center", color:COLORS.accent, fontSize:16 }}>✉</div>
                      <div style={{ flex:1 }}>
                        <div style={{ fontWeight:500, color:COLORS.text }}>{inbox}</div>
                        <div style={{ fontSize:11, color:COLORS.textMuted, marginTop:2 }}>{n} ticket{n!==1?"s":""}</div>
                      </div>
                      <Badge label="Synced" color={COLORS.success} bg={COLORS.successLight}/>
                    </Card>
                  );
                })}
              </div>
            </div>
          )}

          {/* ── Agents ── */}
          {page==="agents"&&(
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:12 }}>
              {AGENTS.map((agent,i)=>{
                const total = agentStats[agent]?.total ?? tickets.filter(t=>Array.isArray(t.assignedTo)?t.assignedTo.includes(agent):t.assignedTo===agent).length;
                const open = agentStats[agent]?.open ?? 0;
                const colors=[COLORS.accent,"#7c3aed","#0ea5e9","#16a34a","#d97706","#e84949","#9333ea","#0891b2"];
                return (
                  <Card key={agent} style={{ padding:16 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12 }}>
                      <Avatar name={agent} size={36} color={colors[i%colors.length]}/>
                      <div>
                        <div style={{ fontWeight:500, color:COLORS.text }}>{agent}</div>
                        <div style={{ fontSize:11, color:COLORS.textMuted }}>AP Agent</div>
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:6 }}>
                      <Badge label={`${total} total`} color={COLORS.textMuted} bg={COLORS.bg}/>
                      <Badge label={`${open} open`} color={colors[i%colors.length]} bg={colors[i%colors.length]+"18"}/>
                    </div>
                  </Card>
                );
              })}
            </div>
          )}

          {page==="users"      && <UsersPage/>}
          {page==="properties" && <PropertiesPage/>}
          {page==="reports"    && (
            <ReportsPage
              user={user}
              onTicketClick={(t)=>{
                setSelected({
                  ...t,
                  assignedTo: t.assigned_to ? t.assigned_to.split(',') : ['Unassigned'],
                  isVIP: t.is_vip===1||t.is_vip===true,
                  date: t.created_at,
                });
                setPage("tickets");
              }}
            />
          )}
        </div>
      </div>
    </div>
    </>
  );
}
